import dayjs from "dayjs";
import { debugConsole } from "utilz/helpers";
import type { BillingTemplateType } from "./types";

export const AppBarHeight = "56px";

export const MAX_INTEGER_SIZE = 20000000; // 20 million - max size for an integer (20 million * 100) in postgress db
export const UrgencyData = [
  { label: "Critical", value: "critical" },
  { label: "High", value: "high" },
  { label: "Medium", value: "medium" },
  { label: "Low", value: "low" },
];
export const PriorityData = [
  { label: "Critical", value: "critical" },
  { label: "High", value: "high" },
  { label: "Medium", value: "medium" },
  { label: "Low", value: "low" },
];

export const NoContractId = "254a5c08-0c80-43e9-bf45-39331edb9b70";

export enum statusData {
  NEW = "9dd09ea5-e30e-494a-9120-583caff52a3a",
  CLOSED = "da5be1f9-db9d-4c64-8e43-51b458746773",
  REOPEN = "30f434a9-4e66-4bea-86e3-86bb945035b3",
  CANCELLED = "953b24ef-2167-49f9-88d9-a06cca165753",
  MERGED = "caf3b9ab-08a5-4014-938c-aacc021f043b",
  ESCALATED = "b8f2e1d4-3a7c-4f9e-b6d5-2c1a0e8f7b3a",

  ASSIGNED = "789c8882-2f6b-495c-ad91-3c9bcbbcc3c7",
  IN_PROGRESS = "e246583c-8714-4c90-a7cc-e3e2d576e780",
  COMPLETED = "2b6f0a8d-b3fe-4a0e-ae59-aaa894c85418",
  WAITING_ON_CUSTOMER = "f3a6c8c2-7c1f-4de6-bad3-9d013b9d4e76",
}

export const BillingCycleOptions: any[] = [
  ...(import.meta.env["VITE_APP_NODE_ENV"] !== "PROD"
    ? [{ label: "Daily", value: "daily" }]
    : []),
  {
    label: "Weekly",
    value: "weekly",
  },
  {
    label: "Monthly",
    value: "monthly",
  },
  {
    label: "Quarterly",
    value: "quarterly",
  },
  {
    label: "Annually",
    value: "annually",
  },
];

export const PRESERVE_CASE_CONSTANTS = [
  "DeskDay",
  "Xero",
  "QuickBooks",
  "Microsoft",
  "Google",
  "NinjaOne",
  "Level",
  "N-able",
  "Hudu",
  "Datto",
  "Stripe",
  "Pax8",
  "IT-Connect",
  "MS Teams",
  "DD/MM/YYYY",
  "MM/DD/YYYY",
  "YYYY/MM/DD",
];

export const AllDefaultStatus: Record<string, any> = {
  New: {
    label: "New",
    value: statusData.NEW,
  },
  Closed: {
    label: "Closed",
    value: statusData.CLOSED,
  },
  Cancelled: {
    label: "Cancelled",
    value: statusData.CANCELLED,
  },
  Merged: {
    label: "Merged",
    value: statusData.MERGED,
  },
  Assigned: {
    label: "Assigned",
    value: "789c8882-2f6b-495c-ad91-3c9bcbbcc3c7",
  },
  Pending: {
    label: "Pending",
    value: "c302d5e0-176c-4396-9f2c-e6742af81a43",
  },
  "In Progress": {
    label: "In Progress",
    value: "e246583c-8714-4c90-a7cc-e3e2d576e780",
  },
  Reopened: {
    label: "Reopened",
    value: statusData.REOPEN,
  },
  Completed: {
    label: "Completed",
    value: "2b6f0a8d-b3fe-4a0e-ae59-aaa894c85418",
  },
  Others: {
    label: "Others",
    value: null,
  },
};

export const DisabledStatus: Array<string> = [
  statusData.CLOSED,
  statusData.CANCELLED,
  statusData.MERGED,
];

export const YearOptions = (date?: string) => {
  try {
    const currentYear = dayjs(date).year();
    return Array.from({ length: currentYear - 2022 + 1 }, (_, index) => ({
      label: (currentYear - index).toString(),
      value: currentYear - index,
    }));
  } catch (e) {
    debugConsole("🚀 ~ YearOptions ~ e:", e);
    return [
      { label: "2026", value: 2026 },
      { label: "2025", value: 2025 },
      { label: "2024", value: 2024 },
      { label: "2023", value: 2023 },
      { label: "2022", value: 2022 },
    ];
  }
};

export const MonthOptions = [
  { label: "January", value: 1 },
  { label: "February", value: 2 },
  { label: "March", value: 3 },
  { label: "April", value: 4 },
  { label: "May", value: 5 },
  { label: "June", value: 6 },
  { label: "July", value: 7 },
  { label: "August", value: 8 },
  { label: "September", value: 9 },
  { label: "October", value: 10 },
  { label: "November", value: 11 },
  { label: "December", value: 12 },
];

export const WeekDaysOptions = [
  { label: "Sunday", value: 0 },
  { label: "Monday", value: 1 },
  { label: "Tuesday", value: 2 },
  { label: "Wednesday", value: 3 },
  { label: "Thursday", value: 4 },
  { label: "Friday", value: 5 },
  { label: "Saturday", value: 6 },
];

export const PaymentTermOptions = [
  { label: "Due on receipt", value: 0 },
  { label: "NET 5", value: 5 },
  { label: "NET 7", value: 7 },
  { label: "NET 10", value: 10 },
  { label: "NET 15", value: 15 },
  { label: "NET 30", value: 30 },
  { label: "NET 45", value: 45 },
  { label: "NET 60", value: 60 },
];

export const BillingTemplateTypeLabels: Record<BillingTemplateType, string> = {
  general: "General",
  "customer-specific": "Customer specific",
};

export const NCENTRALID = "9ef2d0e7-815b-4d02-895c-9a8cc1b0105f";

export const ALL_ROLE_ID = "fcbd88f6-dec3-404b-8cd0-425a845d0766";

export const BillingIntergrations = ["qb"];

export const TicketHeaders = [
  {
    name: "Ticket ID",
    sortable: false,
    key: "u_id",
  },
  {
    name: "Customer",
    sortable: true,
    key: "customer_name",
  },
  {
    name: "User",
    sortable: true,
    key: "customer_user_first_name",
  },
  {
    name: "Priority",
    sortable: true,
    key: "priority",
  },
  {
    name: "Summary",
    sortable: false,
    key: "ticket_summary",
  },
  {
    name: "Status",
    sortable: true,
    key: "status_name",
  },

  {
    name: "Age",
    sortable: true,
    key: "created_at",
  },
  {
    name: "SLA",
    sortable: false,
    key: "sla_name",
  },
  {
    name: "Response SLA",
    sortable: false,
    key: "response_sla",
  },
  {
    name: "Resolution SLA",
    sortable: false,
    key: "resolution_sla",
  },
  {
    name: "Assignees",
    sortable: false,
    key: "assignees",
  },
  {
    name: "Board",
    sortable: true,
    key: "board_name",
  },
  {
    name: "Site",
    sortable: false,
    key: "ticket_site_name",
  },
  {
    name: "Budgeted Hours",
    sortable: true,
    key: "budgeted_hours",
  },
  {
    name: "Actual Hours",
    sortable: true,
    key: "actual_hours",
  },
  {
    name: "Work Type",
    sortable: true,
    key: "work_type_name",
  },
  // {
  //   name: "Impact",
  //   sortable: true,
  //   key: "impact",
  // },
  {
    name: "Service category",
    sortable: true,
    key: "type_name",
  },
  {
    name: "Feedback",
    sortable: true,
    key: "rating",
  },
];

export const TicketQaBoardHeaders = [
  {
    name: "ID Number",
    sortable: true,
    key: "uid",
  },
  {
    name: "Boards",
    sortable: true,
    key: "board",
  },
  {
    name: "Customers",
    sortable: true,
    key: "customer",
  },
  {
    name: "Summary",
    sortable: false,
    key: "summary",
  },
  {
    name: "QA Health Status",
    sortable: true,
    key: "qa_health_status",
  },
];

export const IndustryList = [
  {
    value: "IT",
    label: "IT",
  },
  {
    value: "Health Care",
    label: "Health Care",
  },
  {
    value: "Manufacturing",
    label: "Manufacturing",
  },
  {
    value: "Construction",
    label: "Construction",
  },
  {
    value: "Education",
    label: "Education",
  },
  {
    value: "Retail",
    label: "Retail",
  },
  {
    value: "Finance",
    label: "Finance",
  },
  {
    value: "Telecommunication",
    label: "Telecommunication",
  },
  {
    value: "Others",
    label: "Others",
  },
];

export const CompanySignatureChipOptions = [
  {
    id: "address1",
    label: "Company Address",
    value: "address1",
    data_key: "address1",
  },
  {
    id: "brandName",
    label: "Company Brand Name",
    value: "brand-name",
    data_key: "brand_name",
  },
  {
    id: "companyName",
    label: "Company Name",
    value: "company-name",
    data_key: "company_name",
  },
  {
    id: "country",
    label: "Country",
    value: "country",
    data_key: "country_name",
  },
  {
    id: "state",
    label: "State",
    value: "state",
    data_key: "state_name",
  },
];

export const IndividualSignatureChipOptions = [
  {
    id: "departmentResource",
    label: "Department",
    value: "department",
    data_key: "department",
  },
  {
    id: "firstNameResource",
    label: "First Name",
    value: "first-name",
    data_key: "first_name",
  },
  {
    id: "lastNameResource",
    label: "Last Name",
    value: "last-name",
    data_key: "last_name",
  },
  {
    id: "locationResource",
    label: "Location",
    value: "location",
    data_key: "location_name",
  },
  {
    id: "phoneNumberResource",
    label: "Phone Number",
    value: "phone-number",
    data_key: "phone_number",
  },
  {
    id: "workRoleResource",
    label: "Billing role",
    value: "work-role",
    data_key: "work_role_name",
  },
  {
    id: "workTypeResource",
    label: "Work Type",
    value: "work-type",
    data_key: "work_type_name",
  },
];

const TimeZones = [
  {
    gmtOffsetName: "Africa/Abidjan",
    zoneName: "+00:00",
  },
  {
    gmtOffsetName: "Africa/Accra",
    zoneName: "+00:00",
  },
  {
    gmtOffsetName: "Africa/Addis_Ababa",
    zoneName: "+03:00",
  },
  {
    gmtOffsetName: "Africa/Algiers",
    zoneName: "+01:00",
  },
  {
    gmtOffsetName: "Africa/Asmara",
    zoneName: "+03:00",
  },
  {
    gmtOffsetName: "Africa/Asmera",
    zoneName: "+03:00",
  },
  {
    gmtOffsetName: "Africa/Bamako",
    zoneName: "+00:00",
  },
  {
    gmtOffsetName: "Africa/Bangui",
    zoneName: "+01:00",
  },
  {
    gmtOffsetName: "Africa/Banjul",
    zoneName: "+00:00",
  },
  {
    gmtOffsetName: "Africa/Blantyre",
    zoneName: "+02:00",
  },
  {
    gmtOffsetName: "Africa/Brazzaville",
    zoneName: "+01:00",
  },
  {
    gmtOffsetName: "Africa/Bujumbura",
    zoneName: "+02:00",
  },
  {
    gmtOffsetName: "Africa/Cairo",
    zoneName: "+02:00",
  },
  {
    gmtOffsetName: "Africa/Casablanca",
    zoneName: "+00:00",
  },
  {
    gmtOffsetName: "Africa/Ceuta",
    zoneName: "+01:00",
  },
  {
    gmtOffsetName: "Africa/Conakry",
    zoneName: "+00:00",
  },
  {
    gmtOffsetName: "Africa/Dakar",
    zoneName: "+00:00",
  },
  {
    gmtOffsetName: "Africa/Dar_es_Salaam",
    zoneName: "+03:00",
  },
  {
    gmtOffsetName: "Africa/Djibouti",
    zoneName: "+03:00",
  },
  {
    gmtOffsetName: "Africa/Douala",
    zoneName: "+01:00",
  },
  {
    gmtOffsetName: "Africa/El_Aaiun",
    zoneName: "+00:00",
  },
  {
    gmtOffsetName: "Africa/Freetown",
    zoneName: "+00:00",
  },
  {
    gmtOffsetName: "Africa/Gaborone",
    zoneName: "+02:00",
  },
  {
    gmtOffsetName: "Africa/Harare",
    zoneName: "+02:00",
  },
  {
    gmtOffsetName: "Africa/Johannesburg",
    zoneName: "+02:00",
  },
  {
    gmtOffsetName: "Africa/Juba",
    zoneName: "+03:00",
  },
  {
    gmtOffsetName: "Africa/Kampala",
    zoneName: "+03:00",
  },
  {
    gmtOffsetName: "Africa/Khartoum",
    zoneName: "+03:00",
  },
  {
    gmtOffsetName: "Africa/Kigali",
    zoneName: "+02:00",
  },
  {
    gmtOffsetName: "Africa/Kinshasa",
    zoneName: "+01:00",
  },
  {
    gmtOffsetName: "Africa/Lagos",
    zoneName: "+01:00",
  },
  {
    gmtOffsetName: "Africa/Libreville",
    zoneName: "+01:00",
  },
  {
    gmtOffsetName: "Africa/Lome",
    zoneName: "+00:00",
  },
  {
    gmtOffsetName: "Africa/Luanda",
    zoneName: "+01:00",
  },
  {
    gmtOffsetName: "Africa/Lubumbashi",
    zoneName: "+02:00",
  },
  {
    gmtOffsetName: "Africa/Lusaka",
    zoneName: "+02:00",
  },
  {
    gmtOffsetName: "Africa/Malabo",
    zoneName: "+01:00",
  },
  {
    gmtOffsetName: "Africa/Maputo",
    zoneName: "+02:00",
  },
  {
    gmtOffsetName: "Africa/Maseru",
    zoneName: "+02:00",
  },
  {
    gmtOffsetName: "Africa/Mbabane",
    zoneName: "+02:00",
  },
  {
    gmtOffsetName: "Africa/Mogadishu",
    zoneName: "+03:00",
  },
  {
    gmtOffsetName: "Africa/Monrovia",
    zoneName: "+00:00",
  },
  {
    gmtOffsetName: "Africa/Nairobi",
    zoneName: "+03:00",
  },
  {
    gmtOffsetName: "Africa/Ndjamena",
    zoneName: "+01:00",
  },
  {
    gmtOffsetName: "Africa/Niamey",
    zoneName: "+01:00",
  },
  {
    gmtOffsetName: "Africa/Nouakchott",
    zoneName: "+00:00",
  },
  {
    gmtOffsetName: "Africa/Ouagadougou",
    zoneName: "+00:00",
  },
  {
    gmtOffsetName: "Africa/Porto-Novo",
    zoneName: "+01:00",
  },
  {
    gmtOffsetName: "Africa/Sao_Tome",
    zoneName: "+00:00",
  },
  {
    gmtOffsetName: "Africa/Timbuktu",
    zoneName: "+00:00",
  },
  {
    gmtOffsetName: "Africa/Tripoli",
    zoneName: "+02:00",
  },
  {
    gmtOffsetName: "Africa/Tunis",
    zoneName: "+01:00",
  },
  {
    gmtOffsetName: "Africa/Windhoek",
    zoneName: "+01:00",
  },
  {
    gmtOffsetName: "America/Adak",
    zoneName: "-10:00",
  },
  {
    gmtOffsetName: "America/Anchorage",
    zoneName: "-09:00",
  },
  {
    gmtOffsetName: "America/Anguilla",
    zoneName: "-04:00",
  },
  {
    gmtOffsetName: "America/Antigua",
    zoneName: "-04:00",
  },
  {
    gmtOffsetName: "America/Araguaina",
    zoneName: "-03:00",
  },
  {
    gmtOffsetName: "America/Argentina/Buenos_Aires",
    zoneName: "-03:00",
  },
  {
    gmtOffsetName: "America/Argentina/Catamarca",
    zoneName: "-03:00",
  },
  {
    gmtOffsetName: "America/Argentina/ComodRivadavia",
    zoneName: "-03:00",
  },
  {
    gmtOffsetName: "America/Argentina/Cordoba",
    zoneName: "-03:00",
  },
  {
    gmtOffsetName: "America/Argentina/Jujuy",
    zoneName: "-03:00",
  },
  {
    gmtOffsetName: "America/Argentina/La_Rioja",
    zoneName: "-03:00",
  },
  {
    gmtOffsetName: "America/Argentina/Mendoza",
    zoneName: "-03:00",
  },
  {
    gmtOffsetName: "America/Argentina/Rio_Gallegos",
    zoneName: "-03:00",
  },
  {
    gmtOffsetName: "America/Argentina/Salta",
    zoneName: "-03:00",
  },
  {
    gmtOffsetName: "America/Argentina/San_Juan",
    zoneName: "-03:00",
  },
  {
    gmtOffsetName: "America/Argentina/San_Luis",
    zoneName: "-03:00",
  },
  {
    gmtOffsetName: "America/Argentina/Tucuman",
    zoneName: "-03:00",
  },
  {
    gmtOffsetName: "America/Argentina/Ushuaia",
    zoneName: "-03:00",
  },
  {
    gmtOffsetName: "America/Aruba",
    zoneName: "-04:00",
  },
  {
    gmtOffsetName: "America/Asuncion",
    zoneName: "-04:00",
  },
  {
    gmtOffsetName: "America/Atikokan",
    zoneName: "-05:00",
  },
  {
    gmtOffsetName: "America/Atka",
    zoneName: "-10:00",
  },
  {
    gmtOffsetName: "America/Bahia",
    zoneName: "-03:00",
  },
  {
    gmtOffsetName: "America/Bahia_Banderas",
    zoneName: "-06:00",
  },
  {
    gmtOffsetName: "America/Barbados",
    zoneName: "-04:00",
  },
  {
    gmtOffsetName: "America/Belem",
    zoneName: "-03:00",
  },
  {
    gmtOffsetName: "America/Belize",
    zoneName: "-06:00",
  },
  {
    gmtOffsetName: "America/Blanc-Sablon",
    zoneName: "-04:00",
  },
  {
    gmtOffsetName: "America/Boa_Vista",
    zoneName: "-04:00",
  },
  {
    gmtOffsetName: "America/Bogota",
    zoneName: "-05:00",
  },
  {
    gmtOffsetName: "America/Boise",
    zoneName: "-07:00",
  },
  {
    gmtOffsetName: "America/Buenos_Aires",
    zoneName: "-03:00",
  },
  {
    gmtOffsetName: "America/Cambridge_Bay",
    zoneName: "-07:00",
  },
  {
    gmtOffsetName: "America/Campo_Grande",
    zoneName: "-04:00",
  },
  {
    gmtOffsetName: "America/Cancun",
    zoneName: "-06:00",
  },
  {
    gmtOffsetName: "America/Caracas",
    zoneName: "-04:30",
  },
  {
    gmtOffsetName: "America/Catamarca",
    zoneName: "-03:00",
  },
  {
    gmtOffsetName: "America/Cayenne",
    zoneName: "-03:00",
  },
  {
    gmtOffsetName: "America/Cayman",
    zoneName: "-05:00",
  },
  {
    gmtOffsetName: "America/Chicago",
    zoneName: "-06:00",
  },
  {
    gmtOffsetName: "America/Chihuahua",
    zoneName: "-07:00",
  },
  {
    gmtOffsetName: "America/Coral_Harbour",
    zoneName: "-05:00",
  },
  {
    gmtOffsetName: "America/Cordoba",
    zoneName: "-03:00",
  },
  {
    gmtOffsetName: "America/Costa_Rica",
    zoneName: "-06:00",
  },
  {
    gmtOffsetName: "America/Creston",
    zoneName: "-07:00",
  },
  {
    gmtOffsetName: "America/Cuiaba",
    zoneName: "-04:00",
  },
  {
    gmtOffsetName: "America/Curacao",
    zoneName: "-04:00",
  },
  {
    gmtOffsetName: "America/Danmarkshavn",
    zoneName: "+00:00",
  },
  {
    gmtOffsetName: "America/Dawson",
    zoneName: "-08:00",
  },
  {
    gmtOffsetName: "America/Dawson_Creek",
    zoneName: "-07:00",
  },
  {
    gmtOffsetName: "America/Denver",
    zoneName: "-07:00",
  },
  {
    gmtOffsetName: "America/Detroit",
    zoneName: "-05:00",
  },
  {
    gmtOffsetName: "America/Dominica",
    zoneName: "-04:00",
  },
  {
    gmtOffsetName: "America/Edmonton",
    zoneName: "-07:00",
  },
  {
    gmtOffsetName: "America/Eirunepe",
    zoneName: "-05:00",
  },
  {
    gmtOffsetName: "America/El_Salvador",
    zoneName: "-06:00",
  },
  {
    gmtOffsetName: "America/Ensenada",
    zoneName: "-08:00",
  },
  {
    gmtOffsetName: "America/Fort_Wayne",
    zoneName: "-05:00",
  },
  {
    gmtOffsetName: "America/Fortaleza",
    zoneName: "-03:00",
  },
  {
    gmtOffsetName: "America/Glace_Bay",
    zoneName: "-04:00",
  },
  {
    gmtOffsetName: "America/Godthab",
    zoneName: "-03:00",
  },
  {
    gmtOffsetName: "America/Goose_Bay",
    zoneName: "-04:00",
  },
  {
    gmtOffsetName: "America/Grand_Turk",
    zoneName: "-05:00",
  },
  {
    gmtOffsetName: "America/Grenada",
    zoneName: "-04:00",
  },
  {
    gmtOffsetName: "America/Guadeloupe",
    zoneName: "-04:00",
  },
  {
    gmtOffsetName: "America/Guatemala",
    zoneName: "-06:00",
  },
  {
    gmtOffsetName: "America/Guayaquil",
    zoneName: "-05:00",
  },
  {
    gmtOffsetName: "America/Guyana",
    zoneName: "-04:00",
  },
  {
    gmtOffsetName: "America/Halifax",
    zoneName: "-04:00",
  },
  {
    gmtOffsetName: "America/Havana",
    zoneName: "-05:00",
  },
  {
    gmtOffsetName: "America/Hermosillo",
    zoneName: "-07:00",
  },
  {
    gmtOffsetName: "America/Indiana/Indianapolis",
    zoneName: "-05:00",
  },
  {
    gmtOffsetName: "America/Indiana/Knox",
    zoneName: "-06:00",
  },
  {
    gmtOffsetName: "America/Indiana/Marengo",
    zoneName: "-05:00",
  },
  {
    gmtOffsetName: "America/Indiana/Petersburg",
    zoneName: "-05:00",
  },
  {
    gmtOffsetName: "America/Indiana/Tell_City",
    zoneName: "-06:00",
  },
  {
    gmtOffsetName: "America/Indiana/Valparaiso",
    zoneName: "-06:00",
  },
  {
    gmtOffsetName: "America/Indiana/Vevay",
    zoneName: "-05:00",
  },
  {
    gmtOffsetName: "America/Indiana/Vincennes",
    zoneName: "-05:00",
  },
  {
    gmtOffsetName: "America/Indiana/Winamac",
    zoneName: "-05:00",
  },
  {
    gmtOffsetName: "America/Indianapolis",
    zoneName: "-05:00",
  },
  {
    gmtOffsetName: "America/Inuvik",
    zoneName: "-07:00",
  },
  {
    gmtOffsetName: "America/Iqaluit",
    zoneName: "-05:00",
  },
  {
    gmtOffsetName: "America/Jamaica",
    zoneName: "-05:00",
  },
  {
    gmtOffsetName: "America/Jujuy",
    zoneName: "-03:00",
  },
  {
    gmtOffsetName: "America/Juneau",
    zoneName: "-09:00",
  },
  {
    gmtOffsetName: "America/Kentucky/Louisville",
    zoneName: "-05:00",
  },
  {
    gmtOffsetName: "America/Kentucky/Monticello",
    zoneName: "-05:00",
  },
  {
    gmtOffsetName: "America/Knox_IN",
    zoneName: "-06:00",
  },
  {
    gmtOffsetName: "America/Kralendijk",
    zoneName: "-04:00",
  },
  {
    gmtOffsetName: "America/La_Paz",
    zoneName: "-04:00",
  },
  {
    gmtOffsetName: "America/Lima",
    zoneName: "-05:00",
  },
  {
    gmtOffsetName: "America/Los_Angeles",
    zoneName: "-08:00",
  },
  {
    gmtOffsetName: "America/Louisville",
    zoneName: "-05:00",
  },
  {
    gmtOffsetName: "America/Lower_Princes",
    zoneName: "-04:00",
  },
  {
    gmtOffsetName: "America/Maceio",
    zoneName: "-03:00",
  },
  {
    gmtOffsetName: "America/Managua",
    zoneName: "-06:00",
  },
  {
    gmtOffsetName: "America/Manaus",
    zoneName: "-04:00",
  },
  {
    gmtOffsetName: "America/Marigot",
    zoneName: "-04:00",
  },
  {
    gmtOffsetName: "America/Martinique",
    zoneName: "-04:00",
  },
  {
    gmtOffsetName: "America/Matamoros",
    zoneName: "-06:00",
  },
  {
    gmtOffsetName: "America/Mazatlan",
    zoneName: "-07:00",
  },
  {
    gmtOffsetName: "America/Mendoza",
    zoneName: "-03:00",
  },
  {
    gmtOffsetName: "America/Menominee",
    zoneName: "-06:00",
  },
  {
    gmtOffsetName: "America/Merida",
    zoneName: "-06:00",
  },
  {
    gmtOffsetName: "America/Metlakatla",
    zoneName: "-08:00",
  },
  {
    gmtOffsetName: "America/Mexico_City",
    zoneName: "-06:00",
  },
  {
    gmtOffsetName: "America/Miquelon",
    zoneName: "-03:00",
  },
  {
    gmtOffsetName: "America/Moncton",
    zoneName: "-04:00",
  },
  {
    gmtOffsetName: "America/Monterrey",
    zoneName: "-06:00",
  },
  {
    gmtOffsetName: "America/Montevideo",
    zoneName: "-03:00",
  },
  {
    gmtOffsetName: "America/Montreal",
    zoneName: "-05:00",
  },
  {
    gmtOffsetName: "America/Montserrat",
    zoneName: "-04:00",
  },
  {
    gmtOffsetName: "America/Nassau",
    zoneName: "-05:00",
  },
  {
    gmtOffsetName: "America/New_York",
    zoneName: "-05:00",
  },
  {
    gmtOffsetName: "America/Nipigon",
    zoneName: "-05:00",
  },
  {
    gmtOffsetName: "America/Nome",
    zoneName: "-09:00",
  },
  {
    gmtOffsetName: "America/Noronha",
    zoneName: "-02:00",
  },
  {
    gmtOffsetName: "America/North_Dakota/Beulah",
    zoneName: "-06:00",
  },
  {
    gmtOffsetName: "America/North_Dakota/Center",
    zoneName: "-06:00",
  },
  {
    gmtOffsetName: "America/North_Dakota/New_Salem",
    zoneName: "-06:00",
  },
  {
    gmtOffsetName: "America/Ojinaga",
    zoneName: "-07:00",
  },
  {
    gmtOffsetName: "America/Panama",
    zoneName: "-05:00",
  },
  {
    gmtOffsetName: "America/Pangnirtung",
    zoneName: "-05:00",
  },
  {
    gmtOffsetName: "America/Paramaribo",
    zoneName: "-03:00",
  },
  {
    gmtOffsetName: "America/Phoenix",
    zoneName: "-07:00",
  },
  {
    gmtOffsetName: "America/Port_of_Spain",
    zoneName: "-04:00",
  },
  {
    gmtOffsetName: "America/Port-au-Prince",
    zoneName: "-05:00",
  },
  {
    gmtOffsetName: "America/Porto_Acre",
    zoneName: "-05:00",
  },
  {
    gmtOffsetName: "America/Porto_Velho",
    zoneName: "-04:00",
  },
  {
    gmtOffsetName: "America/Puerto_Rico",
    zoneName: "-04:00",
  },
  {
    gmtOffsetName: "America/Rainy_River",
    zoneName: "-06:00",
  },
  {
    gmtOffsetName: "America/Rankin_Inlet",
    zoneName: "-06:00",
  },
  {
    gmtOffsetName: "America/Recife",
    zoneName: "-03:00",
  },
  {
    gmtOffsetName: "America/Regina",
    zoneName: "-06:00",
  },
  {
    gmtOffsetName: "America/Resolute",
    zoneName: "-06:00",
  },
  {
    gmtOffsetName: "America/Rio_Branco",
    zoneName: "-05:00",
  },
  {
    gmtOffsetName: "America/Rosario",
    zoneName: "-03:00",
  },
  {
    gmtOffsetName: "America/Santa_Isabel",
    zoneName: "-08:00",
  },
  {
    gmtOffsetName: "America/Santarem",
    zoneName: "-03:00",
  },
  {
    gmtOffsetName: "America/Santiago",
    zoneName: "-03:00",
  },
  {
    gmtOffsetName: "America/Santo_Domingo",
    zoneName: "-04:00",
  },
  {
    gmtOffsetName: "America/Sao_Paulo",
    zoneName: "-03:00",
  },
  {
    gmtOffsetName: "America/Scoresbysund",
    zoneName: "-01:00",
  },
  {
    gmtOffsetName: "America/Shiprock",
    zoneName: "-07:00",
  },
  {
    gmtOffsetName: "America/Sitka",
    zoneName: "-09:00",
  },
  {
    gmtOffsetName: "America/St_Barthelemy",
    zoneName: "-04:00",
  },
  {
    gmtOffsetName: "America/St_Johns",
    zoneName: "-03:30",
  },
  {
    gmtOffsetName: "America/St_Kitts",
    zoneName: "-04:00",
  },
  {
    gmtOffsetName: "America/St_Lucia",
    zoneName: "-04:00",
  },
  {
    gmtOffsetName: "America/St_Thomas",
    zoneName: "-04:00",
  },
  {
    gmtOffsetName: "America/St_Vincent",
    zoneName: "-04:00",
  },
  {
    gmtOffsetName: "America/Swift_Current",
    zoneName: "-06:00",
  },
  {
    gmtOffsetName: "America/Tegucigalpa",
    zoneName: "-06:00",
  },
  {
    gmtOffsetName: "America/Thule",
    zoneName: "-04:00",
  },
  {
    gmtOffsetName: "America/Thunder_Bay",
    zoneName: "-05:00",
  },
  {
    gmtOffsetName: "America/Tijuana",
    zoneName: "-08:00",
  },
  {
    gmtOffsetName: "America/Toronto",
    zoneName: "-05:00",
  },
  {
    gmtOffsetName: "America/Tortola",
    zoneName: "-04:00",
  },
  {
    gmtOffsetName: "America/Vancouver",
    zoneName: "-08:00",
  },
  {
    gmtOffsetName: "America/Virgin",
    zoneName: "-04:00",
  },
  {
    gmtOffsetName: "America/Whitehorse",
    zoneName: "-08:00",
  },
  {
    gmtOffsetName: "America/Winnipeg",
    zoneName: "-06:00",
  },
  {
    gmtOffsetName: "America/Yakutat",
    zoneName: "-09:00",
  },
  {
    gmtOffsetName: "America/Yellowknife",
    zoneName: "-07:00",
  },
  {
    gmtOffsetName: "Antarctica/Casey",
    zoneName: "+11:00",
  },
  {
    gmtOffsetName: "Antarctica/Davis",
    zoneName: "+05:00",
  },
  {
    gmtOffsetName: "Antarctica/DumontDUrville",
    zoneName: "+10:00",
  },
  {
    gmtOffsetName: "Antarctica/Macquarie",
    zoneName: "+11:00",
  },
  {
    gmtOffsetName: "Antarctica/Mawson",
    zoneName: "+05:00",
  },
  {
    gmtOffsetName: "Antarctica/McMurdo",
    zoneName: "+12:00",
  },
  {
    gmtOffsetName: "Antarctica/Palmer",
    zoneName: "-04:00",
  },
  {
    gmtOffsetName: "Antarctica/Rothera",
    zoneName: "-03:00",
  },
  {
    gmtOffsetName: "Antarctica/South_Pole",
    zoneName: "+12:00",
  },
  {
    gmtOffsetName: "Antarctica/Syowa",
    zoneName: "+03:00",
  },
  {
    gmtOffsetName: "Antarctica/Troll",
    zoneName: "+00:00",
  },
  {
    gmtOffsetName: "Antarctica/Vostok",
    zoneName: "+06:00",
  },
  {
    gmtOffsetName: "Arctic/Longyearbyen",
    zoneName: "+01:00",
  },
  {
    gmtOffsetName: "Asia/Aden",
    zoneName: "+03:00",
  },
  {
    gmtOffsetName: "Asia/Almaty",
    zoneName: "+06:00",
  },
  {
    gmtOffsetName: "Asia/Amman",
    zoneName: "+02:00",
  },
  {
    gmtOffsetName: "Asia/Anadyr",
    zoneName: "+12:00",
  },
  {
    gmtOffsetName: "Asia/Aqtau",
    zoneName: "+05:00",
  },
  {
    gmtOffsetName: "Asia/Aqtobe",
    zoneName: "+05:00",
  },
  {
    gmtOffsetName: "Asia/Ashgabat",
    zoneName: "+05:00",
  },
  {
    gmtOffsetName: "Asia/Ashkhabad",
    zoneName: "+05:00",
  },
  {
    gmtOffsetName: "Asia/Baghdad",
    zoneName: "+03:00",
  },
  {
    gmtOffsetName: "Asia/Bahrain",
    zoneName: "+03:00",
  },
  {
    gmtOffsetName: "Asia/Baku",
    zoneName: "+04:00",
  },
  {
    gmtOffsetName: "Asia/Bangkok",
    zoneName: "+07:00",
  },
  {
    gmtOffsetName: "Asia/Beirut",
    zoneName: "+02:00",
  },
  {
    gmtOffsetName: "Asia/Bishkek",
    zoneName: "+06:00",
  },
  {
    gmtOffsetName: "Asia/Brunei",
    zoneName: "+08:00",
  },
  {
    gmtOffsetName: "Asia/Calcutta",
    zoneName: "+05:30",
  },
  {
    gmtOffsetName: "Asia/Choibalsan",
    zoneName: "+08:00",
  },
  {
    gmtOffsetName: "Asia/Chongqing",
    zoneName: "+08:00",
  },
  {
    gmtOffsetName: "Asia/Chungking",
    zoneName: "+08:00",
  },
  {
    gmtOffsetName: "Asia/Colombo",
    zoneName: "+05:30",
  },
  {
    gmtOffsetName: "Asia/Dacca",
    zoneName: "+06:00",
  },
  {
    gmtOffsetName: "Asia/Damascus",
    zoneName: "+02:00",
  },
  {
    gmtOffsetName: "Asia/Dhaka",
    zoneName: "+06:00",
  },
  {
    gmtOffsetName: "Asia/Dili",
    zoneName: "+09:00",
  },
  {
    gmtOffsetName: "Asia/Dubai",
    zoneName: "+04:00",
  },
  {
    gmtOffsetName: "Asia/Dushanbe",
    zoneName: "+05:00",
  },
  {
    gmtOffsetName: "Asia/Gaza",
    zoneName: "+02:00",
  },
  {
    gmtOffsetName: "Asia/Harbin",
    zoneName: "+08:00",
  },
  {
    gmtOffsetName: "Asia/Hebron",
    zoneName: "+02:00",
  },
  {
    gmtOffsetName: "Asia/Ho_Chi_Minh",
    zoneName: "+07:00",
  },
  {
    gmtOffsetName: "Asia/Hong_Kong",
    zoneName: "+08:00",
  },
  {
    gmtOffsetName: "Asia/Hovd",
    zoneName: "+07:00",
  },
  {
    gmtOffsetName: "Asia/Irkutsk",
    zoneName: "+08:00",
  },
  {
    gmtOffsetName: "Asia/Istanbul",
    zoneName: "+02:00",
  },
  {
    gmtOffsetName: "Asia/Jakarta",
    zoneName: "+07:00",
  },
  {
    gmtOffsetName: "Asia/Jayapura",
    zoneName: "+09:00",
  },
  {
    gmtOffsetName: "Asia/Jerusalem",
    zoneName: "+02:00",
  },
  {
    gmtOffsetName: "Asia/Kabul",
    zoneName: "+04:30",
  },
  {
    gmtOffsetName: "Asia/Kamchatka",
    zoneName: "+12:00",
  },
  {
    gmtOffsetName: "Asia/Karachi",
    zoneName: "+05:00",
  },
  {
    gmtOffsetName: "Asia/Kashgar",
    zoneName: "+08:00",
  },
  {
    gmtOffsetName: "Asia/Kathmandu",
    zoneName: "+05:45",
  },
  {
    gmtOffsetName: "Asia/Katmandu",
    zoneName: "+05:45",
  },
  {
    gmtOffsetName: "Asia/Khandyga",
    zoneName: "+09:00",
  },
  {
    gmtOffsetName: "Asia/Kolkata",
    zoneName: "+05:30",
  },
  {
    gmtOffsetName: "Asia/Krasnoyarsk",
    zoneName: "+07:00",
  },
  {
    gmtOffsetName: "Asia/Kuala_Lumpur",
    zoneName: "+08:00",
  },
  {
    gmtOffsetName: "Asia/Kuching",
    zoneName: "+08:00",
  },
  {
    gmtOffsetName: "Asia/Kuwait",
    zoneName: "+03:00",
  },
  {
    gmtOffsetName: "Asia/Macao",
    zoneName: "+08:00",
  },
  {
    gmtOffsetName: "Asia/Macau",
    zoneName: "+08:00",
  },
  {
    gmtOffsetName: "Asia/Magadan",
    zoneName: "+10:00",
  },
  {
    gmtOffsetName: "Asia/Makassar",
    zoneName: "+08:00",
  },
  {
    gmtOffsetName: "Asia/Manila",
    zoneName: "+08:00",
  },
  {
    gmtOffsetName: "Asia/Muscat",
    zoneName: "+04:00",
  },
  {
    gmtOffsetName: "Asia/Nicosia",
    zoneName: "+02:00",
  },
  {
    gmtOffsetName: "Asia/Novokuznetsk",
    zoneName: "+07:00",
  },
  {
    gmtOffsetName: "Asia/Novosibirsk",
    zoneName: "+06:00",
  },
  {
    gmtOffsetName: "Asia/Omsk",
    zoneName: "+06:00",
  },
  {
    gmtOffsetName: "Asia/Oral",
    zoneName: "+05:00",
  },
  {
    gmtOffsetName: "Asia/Phnom_Penh",
    zoneName: "+07:00",
  },
  {
    gmtOffsetName: "Asia/Pontianak",
    zoneName: "+07:00",
  },
  {
    gmtOffsetName: "Asia/Pyongyang",
    zoneName: "+09:00",
  },
  {
    gmtOffsetName: "Asia/Qatar",
    zoneName: "+03:00",
  },
  {
    gmtOffsetName: "Asia/Qyzylorda",
    zoneName: "+06:00",
  },
  {
    gmtOffsetName: "Asia/Rangoon",
    zoneName: "+06:30",
  },
  {
    gmtOffsetName: "Asia/Riyadh",
    zoneName: "+03:00",
  },
  {
    gmtOffsetName: "Asia/Saigon",
    zoneName: "+07:00",
  },
  {
    gmtOffsetName: "Asia/Sakhalin",
    zoneName: "+11:00",
  },
  {
    gmtOffsetName: "Asia/Samarkand",
    zoneName: "+05:00",
  },
  {
    gmtOffsetName: "Asia/Seoul",
    zoneName: "+09:00",
  },
  {
    gmtOffsetName: "Asia/Shanghai",
    zoneName: "+08:00",
  },
  {
    gmtOffsetName: "Asia/Singapore",
    zoneName: "+08:00",
  },
  {
    gmtOffsetName: "Asia/Taipei",
    zoneName: "+08:00",
  },
  {
    gmtOffsetName: "Asia/Tashkent",
    zoneName: "+05:00",
  },
  {
    gmtOffsetName: "Asia/Tbilisi",
    zoneName: "+04:00",
  },
  {
    gmtOffsetName: "Asia/Tehran",
    zoneName: "+03:30",
  },
  {
    gmtOffsetName: "Asia/Tel_Aviv",
    zoneName: "+02:00",
  },
  {
    gmtOffsetName: "Asia/Thimbu",
    zoneName: "+06:00",
  },
  {
    gmtOffsetName: "Asia/Thimphu",
    zoneName: "+06:00",
  },
  {
    gmtOffsetName: "Asia/Tokyo",
    zoneName: "+09:00",
  },
  {
    gmtOffsetName: "Asia/Ujung_Pandang",
    zoneName: "+08:00",
  },
  {
    gmtOffsetName: "Asia/Ulaanbaatar",
    zoneName: "+08:00",
  },
  {
    gmtOffsetName: "Asia/Ulan_Bator",
    zoneName: "+08:00",
  },
  {
    gmtOffsetName: "Asia/Urumqi",
    zoneName: "+08:00",
  },
  {
    gmtOffsetName: "Asia/Ust-Nera",
    zoneName: "+10:00",
  },
  {
    gmtOffsetName: "Asia/Vientiane",
    zoneName: "+07:00",
  },
  {
    gmtOffsetName: "Asia/Vladivostok",
    zoneName: "+10:00",
  },
  {
    gmtOffsetName: "Asia/Yakutsk",
    zoneName: "+09:00",
  },
  {
    gmtOffsetName: "Asia/Yekaterinburg",
    zoneName: "+05:00",
  },
  {
    gmtOffsetName: "Asia/Yerevan",
    zoneName: "+04:00",
  },
  {
    gmtOffsetName: "Atlantic/Azores",
    zoneName: "-01:00",
  },
  {
    gmtOffsetName: "Atlantic/Bermuda",
    zoneName: "-04:00",
  },
  {
    gmtOffsetName: "Atlantic/Canary",
    zoneName: "+00:00",
  },
  {
    gmtOffsetName: "Atlantic/Cape_Verde",
    zoneName: "-01:00",
  },
  {
    gmtOffsetName: "Atlantic/Faeroe",
    zoneName: "+00:00",
  },
  {
    gmtOffsetName: "Atlantic/Faroe",
    zoneName: "+00:00",
  },
  {
    gmtOffsetName: "Atlantic/Jan_Mayen",
    zoneName: "+01:00",
  },
  {
    gmtOffsetName: "Atlantic/Madeira",
    zoneName: "+00:00",
  },
  {
    gmtOffsetName: "Atlantic/Reykjavik",
    zoneName: "+00:00",
  },
  {
    gmtOffsetName: "Atlantic/South_Georgia",
    zoneName: "-02:00",
  },
  {
    gmtOffsetName: "Atlantic/St_Helena",
    zoneName: "+00:00",
  },
  {
    gmtOffsetName: "Atlantic/Stanley",
    zoneName: "-03:00",
  },
  {
    gmtOffsetName: "Australia/ACT",
    zoneName: "+10:00",
  },
  {
    gmtOffsetName: "Australia/Adelaide",
    zoneName: "+09:30",
  },
  {
    gmtOffsetName: "Australia/Brisbane",
    zoneName: "+10:00",
  },
  {
    gmtOffsetName: "Australia/Broken_Hill",
    zoneName: "+09:30",
  },
  {
    gmtOffsetName: "Australia/Canberra",
    zoneName: "+10:00",
  },
  {
    gmtOffsetName: "Australia/Currie",
    zoneName: "+10:00",
  },
  {
    gmtOffsetName: "Australia/Darwin",
    zoneName: "+09:30",
  },
  {
    gmtOffsetName: "Australia/Eucla",
    zoneName: "+08:45",
  },
  {
    gmtOffsetName: "Australia/Hobart",
    zoneName: "+10:00",
  },
  {
    gmtOffsetName: "Australia/LHI",
    zoneName: "+10:30",
  },
  {
    gmtOffsetName: "Australia/Lindeman",
    zoneName: "+10:00",
  },
  {
    gmtOffsetName: "Australia/Lord_Howe",
    zoneName: "+10:30",
  },
  {
    gmtOffsetName: "Australia/Melbourne",
    zoneName: "+10:00",
  },
  {
    gmtOffsetName: "Australia/North",
    zoneName: "+09:30",
  },
  {
    gmtOffsetName: "Australia/NSW",
    zoneName: "+10:00",
  },
  {
    gmtOffsetName: "Australia/Perth",
    zoneName: "+08:00",
  },
  {
    gmtOffsetName: "Australia/Queensland",
    zoneName: "+10:00",
  },
  {
    gmtOffsetName: "Australia/South",
    zoneName: "+09:30",
  },
  {
    gmtOffsetName: "Australia/Sydney",
    zoneName: "+10:00",
  },
  {
    gmtOffsetName: "Australia/Tasmania",
    zoneName: "+10:00",
  },
  {
    gmtOffsetName: "Australia/Victoria",
    zoneName: "+10:00",
  },
  {
    gmtOffsetName: "Australia/West",
    zoneName: "+08:00",
  },
  {
    gmtOffsetName: "Australia/Yancowinna",
    zoneName: "+09:30",
  },
  {
    gmtOffsetName: "Brazil/Acre",
    zoneName: "-05:00",
  },
  {
    gmtOffsetName: "Brazil/DeNoronha",
    zoneName: "-02:00",
  },
  {
    gmtOffsetName: "Brazil/East",
    zoneName: "-03:00",
  },
  {
    gmtOffsetName: "Brazil/West",
    zoneName: "-04:00",
  },
  {
    gmtOffsetName: "Canada/Atlantic",
    zoneName: "-04:00",
  },
  {
    gmtOffsetName: "Canada/Central",
    zoneName: "-06:00",
  },
  // {
  //   gmtOffsetName: "Canada/Eastern",
  //   zoneName: "-05:00",
  // },
  {
    gmtOffsetName: "Canada/East-Saskatchewan",
    zoneName: "-06:00",
  },
  {
    gmtOffsetName: "Canada/Mountain",
    zoneName: "-07:00",
  },
  {
    gmtOffsetName: "Canada/Newfoundland",
    zoneName: "-03:30",
  },
  {
    gmtOffsetName: "Canada/Pacific",
    zoneName: "-08:00",
  },
  {
    gmtOffsetName: "Canada/Saskatchewan",
    zoneName: "-06:00",
  },
  {
    gmtOffsetName: "Canada/Yukon",
    zoneName: "-08:00",
  },
  {
    gmtOffsetName: "Chile/Continental",
    zoneName: "-03:00",
  },
  {
    gmtOffsetName: "Chile/EasterIsland",
    zoneName: "-05:00",
  },
  {
    gmtOffsetName: "Cuba",
    zoneName: "-05:00",
  },
  {
    gmtOffsetName: "Egypt",
    zoneName: "+02:00",
  },
  {
    gmtOffsetName: "Eire",
    zoneName: "+00:00",
  },
  {
    gmtOffsetName: "Etc/GMT",
    zoneName: "+00:00",
  },
  {
    gmtOffsetName: "Etc/GMT+0",
    zoneName: "+00:00",
  },
  {
    gmtOffsetName: "Etc/UCT",
    zoneName: "+00:00",
  },
  {
    gmtOffsetName: "Etc/Universal",
    zoneName: "+00:00",
  },
  {
    gmtOffsetName: "Etc/UTC",
    zoneName: "+00:00",
  },
  {
    gmtOffsetName: "Etc/Zulu",
    zoneName: "+00:00",
  },
  {
    gmtOffsetName: "Europe/Amsterdam",
    zoneName: "+01:00",
  },
  {
    gmtOffsetName: "Europe/Andorra",
    zoneName: "+01:00",
  },
  {
    gmtOffsetName: "Europe/Athens",
    zoneName: "+02:00",
  },
  {
    gmtOffsetName: "Europe/Belfast",
    zoneName: "+00:00",
  },
  {
    gmtOffsetName: "Europe/Belgrade",
    zoneName: "+01:00",
  },
  {
    gmtOffsetName: "Europe/Berlin",
    zoneName: "+01:00",
  },
  {
    gmtOffsetName: "Europe/Bratislava",
    zoneName: "+01:00",
  },
  {
    gmtOffsetName: "Europe/Brussels",
    zoneName: "+01:00",
  },
  {
    gmtOffsetName: "Europe/Bucharest",
    zoneName: "+02:00",
  },
  {
    gmtOffsetName: "Europe/Budapest",
    zoneName: "+01:00",
  },
  {
    gmtOffsetName: "Europe/Busingen",
    zoneName: "+01:00",
  },
  {
    gmtOffsetName: "Europe/Chisinau",
    zoneName: "+02:00",
  },
  {
    gmtOffsetName: "Europe/Copenhagen",
    zoneName: "+01:00",
  },
  {
    gmtOffsetName: "Europe/Dublin",
    zoneName: "+00:00",
  },
  {
    gmtOffsetName: "Europe/Gibraltar",
    zoneName: "+01:00",
  },
  {
    gmtOffsetName: "Europe/Guernsey",
    zoneName: "+00:00",
  },
  {
    gmtOffsetName: "Europe/Helsinki",
    zoneName: "+02:00",
  },
  {
    gmtOffsetName: "Europe/Isle_of_Man",
    zoneName: "+00:00",
  },
  {
    gmtOffsetName: "Europe/Istanbul",
    zoneName: "+02:00",
  },
  {
    gmtOffsetName: "Europe/Jersey",
    zoneName: "+00:00",
  },
  {
    gmtOffsetName: "Europe/Kaliningrad",
    zoneName: "+02:00",
  },
  {
    gmtOffsetName: "Europe/Kiev",
    zoneName: "+02:00",
  },
  {
    gmtOffsetName: "Europe/Lisbon",
    zoneName: "+00:00",
  },
  {
    gmtOffsetName: "Europe/Ljubljana",
    zoneName: "+01:00",
  },
  // {
  //   gmtOffsetName: "Europe/London",
  //   zoneName: "+00:00",
  // },
  {
    gmtOffsetName: "Europe/Luxembourg",
    zoneName: "+01:00",
  },
  {
    gmtOffsetName: "Europe/Madrid",
    zoneName: "+01:00",
  },
  {
    gmtOffsetName: "Europe/Malta",
    zoneName: "+01:00",
  },
  {
    gmtOffsetName: "Europe/Mariehamn",
    zoneName: "+02:00",
  },
  {
    gmtOffsetName: "Europe/Minsk",
    zoneName: "+03:00",
  },
  {
    gmtOffsetName: "Europe/Monaco",
    zoneName: "+01:00",
  },
  {
    gmtOffsetName: "Europe/Moscow",
    zoneName: "+03:00",
  },
  {
    gmtOffsetName: "Europe/Nicosia",
    zoneName: "+02:00",
  },
  {
    gmtOffsetName: "Europe/Oslo",
    zoneName: "+01:00",
  },
  {
    gmtOffsetName: "Europe/Paris",
    zoneName: "+01:00",
  },
  {
    gmtOffsetName: "Europe/Podgorica",
    zoneName: "+01:00",
  },
  {
    gmtOffsetName: "Europe/Prague",
    zoneName: "+01:00",
  },
  {
    gmtOffsetName: "Europe/Riga",
    zoneName: "+02:00",
  },
  {
    gmtOffsetName: "Europe/Rome",
    zoneName: "+01:00",
  },
  {
    gmtOffsetName: "Europe/Samara",
    zoneName: "+04:00",
  },
  {
    gmtOffsetName: "Europe/San_Marino",
    zoneName: "+01:00",
  },
  {
    gmtOffsetName: "Europe/Sarajevo",
    zoneName: "+01:00",
  },
  {
    gmtOffsetName: "Europe/Simferopol",
    zoneName: "+03:00",
  },
  {
    gmtOffsetName: "Europe/Skopje",
    zoneName: "+01:00",
  },
  {
    gmtOffsetName: "Europe/Sofia",
    zoneName: "+02:00",
  },
  {
    gmtOffsetName: "Europe/Stockholm",
    zoneName: "+01:00",
  },
  {
    gmtOffsetName: "Europe/Tallinn",
    zoneName: "+02:00",
  },
  {
    gmtOffsetName: "Europe/Tirane",
    zoneName: "+01:00",
  },
  {
    gmtOffsetName: "Europe/Tiraspol",
    zoneName: "+02:00",
  },
  {
    gmtOffsetName: "Europe/Uzhgorod",
    zoneName: "+02:00",
  },
  {
    gmtOffsetName: "Europe/Vaduz",
    zoneName: "+01:00",
  },
  {
    gmtOffsetName: "Europe/Vatican",
    zoneName: "+01:00",
  },
  {
    gmtOffsetName: "Europe/Vienna",
    zoneName: "+01:00",
  },
  {
    gmtOffsetName: "Europe/Vilnius",
    zoneName: "+02:00",
  },
  {
    gmtOffsetName: "Europe/Volgograd",
    zoneName: "+03:00",
  },
  {
    gmtOffsetName: "Europe/Warsaw",
    zoneName: "+01:00",
  },
  {
    gmtOffsetName: "Europe/Zagreb",
    zoneName: "+01:00",
  },
  {
    gmtOffsetName: "Europe/Zaporozhye",
    zoneName: "+02:00",
  },
  {
    gmtOffsetName: "Europe/Zurich",
    zoneName: "+01:00",
  },
  {
    gmtOffsetName: "GB",
    zoneName: "+00:00",
  },
  {
    gmtOffsetName: "GB-Eire",
    zoneName: "+00:00",
  },
  {
    gmtOffsetName: "GMT",
    zoneName: "+00:00",
  },
  {
    gmtOffsetName: "GMT+0",
    zoneName: "+00:00",
  },
  {
    gmtOffsetName: "GMT0",
    zoneName: "+00:00",
  },
  {
    gmtOffsetName: "GMT-0",
    zoneName: "+00:00",
  },
  {
    gmtOffsetName: "Greenwich",
    zoneName: "+00:00",
  },
  {
    gmtOffsetName: "Hongkong",
    zoneName: "+08:00",
  },
  {
    gmtOffsetName: "Iceland",
    zoneName: "+00:00",
  },
  {
    gmtOffsetName: "Indian/Antananarivo",
    zoneName: "+03:00",
  },
  {
    gmtOffsetName: "Indian/Chagos",
    zoneName: "+06:00",
  },
  {
    gmtOffsetName: "Indian/Christmas",
    zoneName: "+07:00",
  },
  {
    gmtOffsetName: "Indian/Cocos",
    zoneName: "+06:30",
  },
  {
    gmtOffsetName: "Indian/Comoro",
    zoneName: "+03:00",
  },
  {
    gmtOffsetName: "Indian/Kerguelen",
    zoneName: "+05:00",
  },
  {
    gmtOffsetName: "Indian/Mahe",
    zoneName: "+04:00",
  },
  {
    gmtOffsetName: "Indian/Maldives",
    zoneName: "+05:00",
  },
  {
    gmtOffsetName: "Indian/Mauritius",
    zoneName: "+04:00",
  },
  {
    gmtOffsetName: "Indian/Mayotte",
    zoneName: "+03:00",
  },
  {
    gmtOffsetName: "Indian/Reunion",
    zoneName: "+04:00",
  },
  {
    gmtOffsetName: "Iran",
    zoneName: "+03:30",
  },
  {
    gmtOffsetName: "Israel",
    zoneName: "+02:00",
  },
  {
    gmtOffsetName: "Jamaica",
    zoneName: "-05:00",
  },
  {
    gmtOffsetName: "Japan",
    zoneName: "+09:00",
  },
  {
    gmtOffsetName: "Kwajalein",
    zoneName: "+12:00",
  },
  {
    gmtOffsetName: "Libya",
    zoneName: "+02:00",
  },
  {
    gmtOffsetName: "Mexico/BajaNorte",
    zoneName: "-08:00",
  },
  {
    gmtOffsetName: "Mexico/BajaSur",
    zoneName: "-07:00",
  },
  {
    gmtOffsetName: "Mexico/General",
    zoneName: "-06:00",
  },
  {
    gmtOffsetName: "Navajo",
    zoneName: "-07:00",
  },
  {
    gmtOffsetName: "NZ",
    zoneName: "+12:00",
  },
  {
    gmtOffsetName: "NZ-CHAT",
    zoneName: "+12:45",
  },
  {
    gmtOffsetName: "Pacific/Apia",
    zoneName: "+13:00",
  },
  {
    gmtOffsetName: "Pacific/Auckland",
    zoneName: "+12:00",
  },
  {
    gmtOffsetName: "Pacific/Chatham",
    zoneName: "+12:45",
  },
  {
    gmtOffsetName: "Pacific/Chuuk",
    zoneName: "+10:00",
  },
  {
    gmtOffsetName: "Pacific/Easter",
    zoneName: "-06:00",
  },
  {
    gmtOffsetName: "Pacific/Efate",
    zoneName: "+11:00",
  },
  {
    gmtOffsetName: "Pacific/Enderbury",
    zoneName: "+13:00",
  },
  {
    gmtOffsetName: "Pacific/Fakaofo",
    zoneName: "+13:00",
  },
  {
    gmtOffsetName: "Pacific/Fiji",
    zoneName: "+12:00",
  },
  {
    gmtOffsetName: "Pacific/Funafuti",
    zoneName: "+12:00",
  },
  {
    gmtOffsetName: "Pacific/Galapagos",
    zoneName: "-06:00",
  },
  {
    gmtOffsetName: "Pacific/Gambier",
    zoneName: "-09:00",
  },
  {
    gmtOffsetName: "Pacific/Guadalcanal",
    zoneName: "+11:00",
  },
  {
    gmtOffsetName: "Pacific/Guam",
    zoneName: "+10:00",
  },
  {
    gmtOffsetName: "Pacific/Honolulu",
    zoneName: "-10:00",
  },
  {
    gmtOffsetName: "Pacific/Johnston",
    zoneName: "-10:00",
  },
  {
    gmtOffsetName: "Pacific/Kiritimati",
    zoneName: "+14:00",
  },
  {
    gmtOffsetName: "Pacific/Kosrae",
    zoneName: "+11:00",
  },
  {
    gmtOffsetName: "Pacific/Kwajalein",
    zoneName: "+12:00",
  },
  {
    gmtOffsetName: "Pacific/Majuro",
    zoneName: "+12:00",
  },
  {
    gmtOffsetName: "Pacific/Marquesas",
    zoneName: "-09:30",
  },
  {
    gmtOffsetName: "Pacific/Midway",
    zoneName: "-11:00",
  },
  {
    gmtOffsetName: "Pacific/Nauru",
    zoneName: "+12:00",
  },
  {
    gmtOffsetName: "Pacific/Niue",
    zoneName: "-11:00",
  },
  {
    gmtOffsetName: "Pacific/Norfolk",
    zoneName: "+11:30",
  },
  {
    gmtOffsetName: "Pacific/Noumea",
    zoneName: "+11:00",
  },
  {
    gmtOffsetName: "Pacific/Pago_Pago",
    zoneName: "-11:00",
  },
  {
    gmtOffsetName: "Pacific/Palau",
    zoneName: "+09:00",
  },
  {
    gmtOffsetName: "Pacific/Pitcairn",
    zoneName: "-08:00",
  },
  {
    gmtOffsetName: "Pacific/Pohnpei",
    zoneName: "+11:00",
  },
  {
    gmtOffsetName: "Pacific/Ponape",
    zoneName: "+11:00",
  },
  {
    gmtOffsetName: "Pacific/Port_Moresby",
    zoneName: "+10:00",
  },
  {
    gmtOffsetName: "Pacific/Rarotonga",
    zoneName: "-10:00",
  },
  {
    gmtOffsetName: "Pacific/Saipan",
    zoneName: "+10:00",
  },
  {
    gmtOffsetName: "Pacific/Samoa",
    zoneName: "-11:00",
  },
  {
    gmtOffsetName: "Pacific/Tahiti",
    zoneName: "-10:00",
  },
  {
    gmtOffsetName: "Pacific/Tarawa",
    zoneName: "+12:00",
  },
  {
    gmtOffsetName: "Pacific/Tongatapu",
    zoneName: "+13:00",
  },
  {
    gmtOffsetName: "Pacific/Truk",
    zoneName: "+10:00",
  },
  {
    gmtOffsetName: "Pacific/Wake",
    zoneName: "+12:00",
  },
  {
    gmtOffsetName: "Pacific/Wallis",
    zoneName: "+12:00",
  },
  {
    gmtOffsetName: "Pacific/Yap",
    zoneName: "+10:00",
  },
  {
    gmtOffsetName: "Poland",
    zoneName: "+01:00",
  },
  {
    gmtOffsetName: "Portugal",
    zoneName: "+00:00",
  },
  {
    gmtOffsetName: "PRC",
    zoneName: "+08:00",
  },
  {
    gmtOffsetName: "ROC",
    zoneName: "+08:00",
  },
  {
    gmtOffsetName: "ROK",
    zoneName: "+09:00",
  },
  {
    gmtOffsetName: "Singapore",
    zoneName: "+08:00",
  },
  {
    gmtOffsetName: "Turkey",
    zoneName: "+02:00",
  },
  {
    gmtOffsetName: "UCT",
    zoneName: "+00:00",
  },
  {
    gmtOffsetName: "Universal",
    zoneName: "+00:00",
  },
  {
    gmtOffsetName: "US/Alaska",
    zoneName: "-09:00",
  },
  {
    gmtOffsetName: "US/Aleutian",
    zoneName: "-10:00",
  },
  {
    gmtOffsetName: "US/Arizona",
    zoneName: "-07:00",
  },
  // {
  //   gmtOffsetName: "US/Central",
  //   zoneName: "-06:00",
  // },
  {
    gmtOffsetName: "US/Eastern",
    zoneName: "-05:00",
  },
  {
    gmtOffsetName: "US/East-Indiana",
    zoneName: "-05:00",
  },
  {
    gmtOffsetName: "US/Hawaii",
    zoneName: "-10:00",
  },
  {
    gmtOffsetName: "US/Indiana-Starke",
    zoneName: "-06:00",
  },
  {
    gmtOffsetName: "US/Michigan",
    zoneName: "-05:00",
  },
  {
    gmtOffsetName: "US/Mountain",
    zoneName: "-07:00",
  },
  // {
  //   gmtOffsetName: "US/Pacific",
  //   zoneName: "-08:00",
  // },
  {
    gmtOffsetName: "US/Samoa",
    zoneName: "-11:00",
  },
  {
    gmtOffsetName: "UTC",
    zoneName: "+00:00",
  },
  {
    gmtOffsetName: "W-SU",
    zoneName: "+03:00",
  },
  {
    gmtOffsetName: "Zulu",
    zoneName: "+00:00",
  },
];

const mostUserdTimeZones = [
  {
    label: "Pacific Time (US & Canada)",
    gmtOffsetName: "US/Pacific",
    zoneName: "-08:00",
  },
  {
    label: "Mountain Time (US & Canada)",
    gmtOffsetName: "US/Mountain",
    zoneName: "-07:00",
  },
  {
    label: "Central Time (US & Canada)",
    gmtOffsetName: "US/Central",
    zoneName: "-06:00",
  },
  {
    label: "Eastern Time (US & Canada)",
    gmtOffsetName: "Canada/Eastern",
    zoneName: "-05:00",
  },
  {
    label: "Europe/London",
    gmtOffsetName: "Europe/London",
    zoneName: "+00:00",
  },
  {
    label: "Australia/Sydney",
    gmtOffsetName: "Australia/Sydney",
    zoneName: "+10:00",
  },
  // {
  //   label: "Central Daylight Time",
  //   gmtOffsetName: "America/New_York",
  //   zoneName: "-05:00",
  // },
  // {
  //   label: "Eastern Daylight Time",
  //   gmtOffsetName: "Brazil/West",
  //   zoneName: "-04:00",
  // },
  // {
  //   label: "Greenwich Mean Time",
  //   gmtOffsetName: "Europe/London",
  //   zoneName: "+00:00",
  // },
  // {
  //   label: "British Summer Time",
  //   gmtOffsetName: "Poland",
  //   zoneName: "+01:00",
  // },
  // {
  //   label: "Central European Time",
  //   gmtOffsetName: "Europe/Berlin",
  //   zoneName: "+01:00",
  // },
  // {
  //   label: "Indian Standard Time",
  //   gmtOffsetName: "Asia/Calcutta",
  //   zoneName: "+05:30",
  // },
];

function sortObjectsByZoneNameAscending(objects: any[]) {
  return objects.sort((a, b) => a.zoneName.localeCompare(b.zoneName));
}

const newTimeZones = sortObjectsByZoneNameAscending(TimeZones);

export const TimeZoneList = {
  "Popular time zones": (mostUserdTimeZones || []).map((item: any) => {
    return {
      label: `(UTC ${item?.zoneName}) ${item?.label}`,
      value: item?.gmtOffsetName,
    };
  }),
  "All time zones": (newTimeZones || []).map((item: any) => {
    return {
      label: `(UTC ${item?.zoneName}) ${item?.gmtOffsetName}`,
      value: item?.gmtOffsetName,
    };
  }),
};

export const TYPE = {
  SINGLE: "single",
  COLLECTION: "collection",
};

export const RESOURCE_TYPES = {
  SUPERADMIN: "b110abc3-0709-491f-ac04-86eb25159386",
  ADMIN: "9d6afd0e-b353-438d-a34d-1bb1cc5bbf03",
  RESOURCE: "ff1088b8-d50b-4d89-a033-94bf3b9f450d",
};

export const PERMISSION_CONSTANT = [
  {
    serviceDesk: {
      key: "serviceDesk",
      name: "serviceDesk",
      label: "Service desk",
      rule: "",
      type: TYPE.SINGLE,
    },
    tickets: {
      key: "tickets_collection",
      label: "Tickets",
      type: TYPE.COLLECTION,
      contents: {
        tickets: {
          key: "tickets",
          name: "tickets",
          label: "Tickets",
          rule: "",
          type: TYPE.SINGLE,
        },
        createTickets: {
          key: "createTickets",
          name: "createTickets",
          label: "Create ticket",
          rule: "servicedesk::ticket.create",
          type: TYPE.SINGLE,
        },
        addPublicNotes: {
          key: "addPublicNotes",
          name: "addPublicNotes",
          label: "Add public notes",
          rule: "servicedesk::publicnotes.create",
          type: TYPE.SINGLE,
        },
        mergeTickets: {
          key: "mergeTickets",
          name: "mergeTickets",
          label: "Merge tickets",
          rule: "servicedesk::ticket.merge",
          type: TYPE.SINGLE,
        },
        createChildTicket: {
          key: "createChildTicket",
          name: "createChildTicket",
          label: "Create a child ticket",
          rule: "servicedesk::ticket.child",
          type: TYPE.SINGLE,
        },
        linkAChildTicket: {
          key: "linkAChildTicket",
          name: "linkAChildTicket",
          label: "Link a child ticket",
          rule: "servicedesk::ticket.linkchild",
          type: TYPE.SINGLE,
        },
        sendATicketReply: {
          key: "sendATicketReply",
          name: "sendATicketReply",
          label: "Send a ticket reply",
          rule: "servicedesk::ticket.reply",
          type: TYPE.SINGLE,
        },
        editNotes: {
          key: "editNotes",
          name: "editNotes",
          label: "Edit notes",
          rule: "servicedesk::ticket.editnotes",
          type: TYPE.SINGLE,
        },
        editEveryonesNotes: {
          key: "editEveryonesNotes",
          name: "editEveryonesNotes",
          label: "Edit everyones notes",
          rule: "servicedesk::ticket.editeallnotes",
          type: TYPE.SINGLE,
        },
        editTicketProperties: {
          key: "editTicketProperties",
          name: "editTicketProperties",
          label: "Edit ticket properties",
          rule: "servicedesk::ticket.properties",
          type: TYPE.SINGLE,
        },
        addSchedules: {
          key: "addSchedules",
          name: "addSchedules",
          label: "Add schedules",
          rule: "servicedesk::ticket.addschedules",
          type: TYPE.SINGLE,
        },
        deleteSchedules: {
          key: "deleteSchedules",
          name: "deleteSchedules",
          label: "Delete schedules",
          rule: "servicedesk::ticket.deleteschedules",
          type: TYPE.SINGLE,
        },
        addTimeEntries: {
          key: "addTimeEntries",
          name: "addTimeEntries",
          label: "Add time entries",
          rule: "servicedesk::ticket.addtimeentries",
          type: TYPE.SINGLE,
        },
        editTimeEntries: {
          key: "editTimeEntries",
          name: "editTimeEntries",
          label: "Edit time entries",
          rule: "servicedesk::ticket.edittimeentries",
          type: TYPE.SINGLE,
        },
        editEveryonesTimeEntries: {
          key: "editEveryonesTimeEntries",
          name: "editEveryonesTimeEntries",
          label: "Edit every time entries",
          rule: "servicedesk::ticket.editeveryonestimeentries",
          type: TYPE.SINGLE,
        },
        closeATicket: {
          key: "closeATicket",
          name: "closeATicket",
          label: "Close a ticket",
          rule: "servicedesk::ticket.closeticket",
          type: TYPE.SINGLE,
        },
        exportTickets: {
          key: "exportTickets",
          name: "exportTickets",
          label: "Export ticket",
          rule: "servicedesk::ticket.exportticket",
          type: TYPE.SINGLE,
        },
      },
    },
    requests: {
      key: "requests_collection",
      label: "Requests",
      type: TYPE.COLLECTION,
      contents: {
        requests: {
          key: "requests",
          name: "requests",
          label: "Requests",
          rule: "",
          type: TYPE.SINGLE,
        },
        createRequests: {
          key: "createRequests",
          name: "createRequests",
          label: "Create request",
          rule: "servicedesk::request.create",
          type: TYPE.SINGLE,
        },
        sendARequestReply: {
          key: "sendARequestReply",
          name: "sendARequestReply",
          label: "Send a request reply",
          rule: "servicedesk::request.sendreply",
          type: TYPE.SINGLE,
        },
        editRequestProperties: {
          key: "editRequestProperties",
          name: "editRequestProperties",
          label: "Edit request properties",
          rule: "servicedesk::request.editproperties",
          type: TYPE.SINGLE,
        },
        editRequestNotes: {
          key: "editRequestNotes",
          name: "editRequestNotes",
          label: "Edit notes",
          rule: "servicedesk::request.editnotes",
          type: TYPE.SINGLE,
        },
        addRequestSchedules: {
          key: "addRequestSchedules",
          name: "addRequestSchedules",
          label: "Add schedules",
          rule: "servicedesk::request.addschedules",
          type: TYPE.SINGLE,
        },
        deleteRequestSchedules: {
          key: "deleteRequestSchedules",
          name: "deleteRequestSchedules",
          label: "Delete schedules",
          rule: "servicedesk::request.deleteschedules",
          type: TYPE.SINGLE,
        },
        addRequestTimeEntries: {
          key: "addRequestTimeEntries",
          name: "addRequestTimeEntries",
          label: "Add time entries",
          rule: "servicedesk::request.addtimeentries",
          type: TYPE.SINGLE,
        },

        editRequestTimeEntries: {
          key: "editRequestTimeEntries",
          name: "editRequestTimeEntries",
          label: "Edit time etry",
          rule: "servicedesk::request.edittimeentries",
          type: TYPE.SINGLE,
        },
        editEveryoneRequestTimeEntries: {
          key: "editEveryoneRequestTimeEntries",
          name: "editEveryoneRequestTimeEntries",
          label: "Edit everyone's time entry",
          rule: "servicedesk::request.editeveryonestimeentries",
          type: TYPE.SINGLE,
        },
        closeRequests: {
          key: "closeRequests",
          name: "closeRequests",
          label: "Close request",
          rule: "servicedesk::request.closerequests",
          type: TYPE.SINGLE,
        },
        exportRequests: {
          key: "exportRequests",
          name: "exportRequests",
          label: "Export request",
          rule: "servicedesk::request.exportrequests",
          type: TYPE.SINGLE,
        },
      },
    },
    projects: {
      key: "projects_collection",
      label: "Projects",
      type: TYPE.COLLECTION,
      contents: {
        projects: {
          key: "projects",
          name: "projects",
          label: "Projects",
          rule: "",
          type: TYPE.SINGLE,
        },
        createProject: {
          key: "createProject",
          name: "createProject",
          label: "Create project",
          rule: "servicedesk::project.create",
          type: TYPE.SINGLE,
        },
        createPhases: {
          key: "createPhases",
          name: "createPhases",
          label: "Create milestone",
          rule: "servicedesk::project.createphases",
          type: TYPE.SINGLE,
        },
        createTasks: {
          key: "createTasks",
          name: "createTasks",
          label: "Create tasks",
          rule: "servicedesk::project.cratetasks",
          type: TYPE.SINGLE,
        },
        editProjectProperties: {
          key: "editProjectProperties",
          name: "editProjectProperties",
          label: "Edit project properties",
          rule: "servicedesk::project.editprojectproperties",
          type: TYPE.SINGLE,
        },
        addAssigneesToProject: {
          key: "addAssigneesToProject",
          name: "addAssigneesToProject",
          label: "Add assignees to project",
          rule: "servicedesk::project.addassignees",
          type: TYPE.SINGLE,
        },
        sendTaskReply: {
          key: "sendTaskReply",
          name: "sendTaskReply",
          label: "Send task reply",
          rule: "servicedesk::project.sendtaskreply",
          type: TYPE.SINGLE,
        },
        addSchedulesToProject: {
          key: "addSchedulesToProject",
          name: "addSchedulesToProject",
          label: "Add schedules",
          rule: "servicedesk::project.addschedules",
          type: TYPE.SINGLE,
        },
        deleteSchedulesFromProject: {
          key: "deleteSchedulesFromProject",
          name: "deleteSchedulesFromProject",
          label: "Delete schedules",
          rule: "servicedesk::project.deleteschedules",
          type: TYPE.SINGLE,
        },
        editTaskProperties: {
          key: "editTaskProperties",
          name: "editTaskProperties",
          label: "Edit task properties",
          rule: "servicedesk::project.edittaskproperties",
          type: TYPE.SINGLE,
        },
        editProjectNotes: {
          key: "editProjectNotes",
          name: "editProjectNotes",
          label: "Edit notes",
          rule: "servicedesk::project.editnotes",
          type: TYPE.SINGLE,
        },
        addTimeEntriesToProject: {
          key: "addTimeEntriesToProject",
          name: "addTimeEntriesToProject",
          label: "Add time entries",
          rule: "servicedesk::project.addtimeentries",
          type: TYPE.SINGLE,
        },
        editTimeEntriesForProject: {
          key: "editTimeEntriesForProject",
          name: "editTimeEntriesForProject",
          label: "Edit time entries",
          rule: "servicedesk::project.edittimeentries",
          type: TYPE.SINGLE,
        },
        editEveryoneTimeEntriesForProject: {
          key: "editEveryoneTimeEntriesForProject",
          name: "editEveryoneTimeEntriesForProject",
          label: "Edit everyone's time entries",
          rule: "servicedesk::project.editeveryonestimeentries",
          type: TYPE.SINGLE,
        },
        closeTasksInProject: {
          key: "closeTasksInProject",
          name: "closeTasksInProject",
          label: "Close tasks",
          rule: "servicedesk::project.closetasks",
          type: TYPE.SINGLE,
        },
        closeProject: {
          key: "closeProject",
          name: "closeProject",
          label: "Close projects",
          rule: "servicedesk::project.closeproject",
          type: TYPE.SINGLE,
        },
        exportTasksInProject: {
          key: "exportTasksInProject",
          name: "exportTasksInProject",
          label: "Export tasks",
          rule: "servicedesk::project.exporttasks",
          type: TYPE.SINGLE,
        },
        exportProjects: {
          key: "exportProjects",
          name: "exportProjects",
          label: "Export projects",
          rule: "servicedesk::project.exportprojects",
          type: TYPE.SINGLE,
        },
      },
    },
    recurringTasks: {
      key: "recurring_tasks_collection",
      label: "Recurring task",
      type: TYPE.COLLECTION,
      contents: {
        recurringTasks: {
          key: "recurringTasks",
          name: "recurringTasks",
          label: "Recurring task",
          rule: "servicedesk::recurringtasks",
          type: TYPE.SINGLE,
        },
        createRecurringTasks: {
          key: "createRecurringTasks",
          name: "createRecurringTasks",
          label: "Create recurring task",
          rule: "servicedesk::recurringtasks.create",
          type: TYPE.SINGLE,
        },
        addScheduleForEveryone: {
          key: "addScheduleForEveryone",
          name: "addScheduleForEveryone",
          label: "Add schedule for everyone",
          rule: "servicedesk::recurringtasks.addscheduleforeveryone",
          type: TYPE.SINGLE,
        },
        scheduleOneTimeTask: {
          key: "scheduleOneTimeTask",
          name: "scheduleOneTimeTask",
          label: "Schedule one time task",
          rule: "servicedesk::recurringtasks.scheduleonetimetask",
          type: TYPE.SINGLE,
        },
        scheduleDailyTasks: {
          key: "scheduleDailyTasks",
          name: "scheduleDailyTasks",
          label: "Schedule daily task",
          rule: "servicedesk::recurringtasks.scheduledailytasks",
          type: TYPE.SINGLE,
        },
        scheduleWeeklyTask: {
          key: "scheduleWeeklyTask",
          name: "scheduleWeeklyTask",
          label: "Schedule weekly task",
          rule: "servicedesk::recurringtasks.scheduleweeklytasks",
          type: TYPE.SINGLE,
        },
        scheduleMonthlyTask: {
          key: "scheduleMonthlyTask",
          name: "scheduleMonthlyTask",
          label: "Schedule monthly task",
          rule: "servicedesk::recurringtasks.schedulemonthlytasks",
          type: TYPE.SINGLE,
        },
      },
    },
    calendarAndTimesheet: {
      key: "calendar_and_timesheet_collection",
      label: "Calendar & Timesheet",
      type: TYPE.COLLECTION,
      contents: {
        calendarAndTimesheet: {
          key: "calendarAndTimesheet",
          name: "calendarAndTimesheet",
          label: "Calendar & Timesheet",
          rule: "servicedesk::calenderandtimesheet",
          type: TYPE.SINGLE,
        },
        calendar: {
          key: "calendar",
          name: "calendar",
          label: "Calendar",
          rule: "servicedesk::calenderandtimesheet.calendar",
          type: TYPE.SINGLE,
        },
        timesheet: {
          key: "timesheet",
          name: "timesheet",
          label: "Timesheet",
          rule: "servicedesk::calenderandtimesheet.timesheet",
          type: TYPE.SINGLE,
        },
        viewEveryonesCalendar: {
          key: "viewEveryonesCalendar",
          name: "viewEveryonesCalendar",
          label: "View everyones calendar",
          rule: "servicedesk::calenderandtimesheet.vieweveryonescalendar",
          type: TYPE.SINGLE,
        },
        viewEveryonesTimesheet: {
          key: "viewEveryonesTimesheet",
          name: "viewEveryonesTimesheet",
          label: "View everyones timesheet",
          rule: "servicedesk::calenderandtimesheet.vieweveryonestimesheet",
          type: TYPE.SINGLE,
        },
        editEveryonesCalendar: {
          key: "editEveryonesCalendar",
          name: "editEveryonesCalendar",
          label: "Edit everyones calendar",
          rule: "servicedesk::calenderandtimesheet.editeveryonescalendar",
          type: TYPE.SINGLE,
        },
        editEveryonesTimesheet: {
          key: "editEveryonesTimesheet",
          name: "editEveryonesTimesheet",
          label: "Edit everyones timesheet",
          rule: "servicedesk::calenderandtimesheet.editeveryonestimesheet",
          type: TYPE.SINGLE,
        },
      },
    },
  },
  {
    customers: {
      key: "customers_collection",
      label: "Customers",
      type: TYPE.COLLECTION,
      contents: {
        customers: {
          key: "customers",
          name: "customers",
          label: "Customers",
          rule: "",
          type: TYPE.SINGLE,
        },
        addOrEditCustomers: {
          key: "addOrEditCustomers",
          name: "addOrEditCustomers",
          label: "Add/Edit customers",
          rule: "customers::customer.addcustomer",
          type: TYPE.SINGLE,
        },
        addBulkCustomers: {
          key: "addBulkCustomers",
          name: "addBulkCustomers",
          label: "Add bulk customers",
          rule: "customers::customer.bulkaddcustomer",
          type: TYPE.SINGLE,
        },
        sendBroadcastMessage: {
          key: "sendBroadcastMessage",
          name: "sendBroadcastMessage",
          label: "Send announcement",
          rule: "customers::customer.sendboradcastmessage",
          type: TYPE.SINGLE,
        },
        updateCustomerDetails: {
          key: "updateCustomerDetails",
          name: "updateCustomerDetails",
          label: "Update Customer details",
          rule: "customers::customer.updatecustomerdetails",
          type: TYPE.SINGLE,
        },
        denyCustomers: {
          key: "denyCustomers",
          name: "denyCustomers",
          label: "Deny customers",
          rule: "customers::customer.denycustomers",
          type: TYPE.SINGLE,
        },
        deleteCustomers: {
          key: "deleteCustomers",
          name: "deleteCustomers",
          label: "Delete customers",
          rule: "customers::customer.deletecustomers",
          type: TYPE.SINGLE,
        },
        exportCustomers: {
          key: "exportCustomers",
          name: "exportCustomers",
          label: "Export customers",
          rule: "customers::customer.exportcustomers",
          type: TYPE.SINGLE,
        },
      },
    },
    users: {
      key: "users_collection",
      label: "Users",
      type: TYPE.COLLECTION,
      contents: {
        addOrEditUsers: {
          key: "addOrEditUsers",
          name: "addOrEditUsers",
          label: "Add/Edit users",
          rule: "customers:::customer.adduser",
          type: TYPE.SINGLE,
        },
        addBulkUsers: {
          key: "addBulkUsers",
          name: "addBulkUsers",
          label: "Add bulk users",
          rule: "customers:::customer.addbulkuser",
          type: TYPE.SINGLE,
        },
        addSyncAccountforUsers: {
          key: "addSyncAccountforUsers",
          name: "addSyncAccountforUsers",
          label: "Add sync account for users",
          rule: "customers:::customer.syncaccount",
          type: TYPE.SINGLE,
        },
        updateSyncSettings: {
          key: "updateSyncSettings",
          name: "updateSyncSettings",
          label: "Update sync settings",
          rule: "customers:::customer.updatesyncsettings",
          type: TYPE.SINGLE,
        },
        manualSyncUsers: {
          key: "manualSyncUsers",
          name: "manualSyncUsers",
          label: "Manual sync users",
          rule: "customers:::customer.manualsyncuser",
          type: TYPE.SINGLE,
        },
        updateUserDetails: {
          key: "updateUserDetails",
          name: "updateUserDetails",
          label: "Update user details",
          rule: "customers:::customer.updateuserdetails",
          type: TYPE.SINGLE,
        },
        deniedUserGroups: {
          key: "deniedUserGroups",
          name: "deniedUserGroups",
          label: "Denied user groups",
          rule: "customers:::customer.deniedusergroups",
          type: TYPE.SINGLE,
        },
        deleteUsers: {
          key: "deleteUsers",
          name: "deleteUsers",
          label: "Delete users",
          rule: "customers:::customer.deleteusers",
          type: TYPE.SINGLE,
        },
        exportUsers: {
          key: "exportUsers",
          name: "exportUsers",
          label: "Export users",
          rule: "customers:::customer.exportusers",
          type: TYPE.SINGLE,
        },
      },
    },
    broadcastMessages: {
      key: "broadcast_Messages_collection",
      label: "Announcements",
      type: TYPE.COLLECTION,
      contents: {
        broadcastMessages: {
          key: "broadcastMessages",
          name: "broadcastMessages",
          label: "Announcements",
          rule: "customers:::customer.broadcastmessage",
          type: TYPE.SINGLE,
        },
        createNewBroadcastMessages: {
          key: "createNewBroadcastMessages",
          name: "createNewBroadcastMessages",
          label: "Create new announcement",
          rule: "customers:::customer.createnewbroadcastmessage",
          type: TYPE.SINGLE,
        },
        manageBroadcastMessages: {
          key: "manageBroadcastMessages",
          name: "manageBroadcastMessages",
          label: "Manage announcements",
          rule: "customers:::customer.managebroadcastmessages",
          type: TYPE.SINGLE,
        },
      },
    },
  },
  {
    controlCenter: {
      key: "control_center_collection",
      label: "Control center",
      type: TYPE.COLLECTION,
      blockedResource: [RESOURCE_TYPES.RESOURCE],
      contents: {
        addResource: {
          key: "addResource",
          name: "addResource",
          label: "Add resource",
          rule: "controlcenter::msp.addresources",
          type: TYPE.SINGLE,
        },
        addGroups: {
          key: "addGroups",
          name: "addGroups",
          label: "Add  resource groups",
          rule: "controlcenter::msp.addgroups",
          type: TYPE.SINGLE,
        },
        addRole: {
          key: "addRole",
          name: "addRole",
          label: "Add resource types",
          rule: "controlcenter::msp.addrole",
          type: TYPE.SINGLE,
        },
        addMembersToGroup: {
          key: "addMembersToGroup",
          name: "addMembersToGroup",
          label: "Add members to resource group",
          rule: "controlcenter::msp.addmemberstogroup",
          type: TYPE.SINGLE,
        },
        updateWhiteList: {
          key: "updateWhiteList",
          name: "updateWhiteList",
          label: "Update branding settings",
          rule: "controlcenter::msp.updatewhitelist",
          type: TYPE.SINGLE,
        },
        updateSecuritySettings: {
          key: "updateSecuritySettings",
          name: "updateSecuritySettings",
          label: "Update security settings",
          rule: "controlcenter::msp.updatesecuritysettings",
          type: TYPE.SINGLE,
        },
        updateNotificationSettings: {
          key: "updateNotificationSettings",
          name: "updateNotificationSettings",
          label: "Update notification settings",
          rule: "controlcenter::msp.updatenotificationsettings",
          type: TYPE.SINGLE,
        },
        updatePermissions: {
          key: "updatePermissions",
          name: "updatePermissions",
          label: "Update permission",
          rule: "controlcenter::msp.updatepermissions",
          type: TYPE.SINGLE,
        },
        updateResourceDetails: {
          key: "updateResourceDetails",
          name: "updateResourceDetails",
          label: "Update resource details",
          rule: "controlcenter::msp.updateresourcedetails",
          type: TYPE.SINGLE,
        },
        updateEmailSettings: {
          key: "updateEmailSettings",
          name: "updateEmailSettings",
          label: "Update email settings",
          rule: "controlcenter::msp.updateemailsettings",
          type: TYPE.SINGLE,
        },
        updateConversationSettings: {
          key: "updateConversationSettings",
          name: "updateConversationSettings",
          label: "Update conversation settings",
          rule: "controlcenter::msp.updateconversationsettings",
          type: TYPE.SINGLE,
        },
        accessAccountDetails: {
          key: "accessAccountDetails",
          name: "accessAccountDetails",
          label: "Access account details",
          rule: "controlcenter::msp.accessaccountdetails",
          type: TYPE.SINGLE,
        },
        updateAccountDetails: {
          key: "updateAccountDetails",
          name: "updateAccountDetails",
          label: "Update account details",
          rule: "controlcenter::msp.updateaccountdetails",
          type: TYPE.SINGLE,
        },
      },
    },

    servicedeskConfiguration: {
      key: "service_desk_Configuration_collection",
      label: "Service desk configuration",
      type: TYPE.COLLECTION,
      blockedResource: [RESOURCE_TYPES.ADMIN, RESOURCE_TYPES.RESOURCE],
      contents: {
        configuration: {
          key: "configuration",
          name: "configuration",
          label: "Configurations",
          rule: "controlcenter::customerconf.configuration",
          type: TYPE.SINGLE,
        },
        manageGeneralSettings: {
          key: "manageGeneralSettings",
          name: "manageGeneralSettings",
          label: "Manage general settings",
          rule: "controlcenter:configuration.generalsettings",
          type: TYPE.SINGLE,
        },
        manageWidgets: {
          key: "manageWidgets",
          name: "manageWidgets",
          label: "Manage widgets",
          rule: "controlcenter:configuration.widgets",
          type: TYPE.SINGLE,
        },
        manageAttributes: {
          key: "manageAttributes",
          name: "manageAttributes",
          label: "Manage attributes",
          rule: "controlcenter:configuration.attributes",
          type: TYPE.SINGLE,
        },
        manageTags: {
          key: "manageTags",
          name: "manageTags",
          label: "Manage tags",
          rule: "controlcenter:configuration.tags",
          type: TYPE.SINGLE,
        },
        manageBoards: {
          key: "manageBoards",
          name: "manageBoards",
          label: "Manage boards",
          rule: "controlcenter:configuration.boards",
          type: TYPE.SINGLE,
        },
        manageTicketTemplates: {
          key: "manageTicketTemplates",
          name: "manageTicketTemplates",
          label: "Manage ticket templates",
          rule: "controlcenter:configuration.tickettemplates",
          type: TYPE.SINGLE,
        },
        manageRequestTemplates: {
          key: "manageRequestTemplates",
          name: "manageRequestTemplates",
          label: "Manage request templates",
          rule: "controlcenter:configuration.requesttemplates",
          type: TYPE.SINGLE,
        },
        manageProjectTemplates: {
          key: "manageProjectTemplates",
          name: "manageProjectTemplates",
          label: "Manage project templates",
          rule: "controlcenter:configuration.projecttemplates",
          type: TYPE.SINGLE,
        },
        manageCannedResponses: {
          key: "manageCannedResponses",
          name: "manageCannedResponses",
          label: "Manage canned responses",
          rule: "controlcenter:configuration.cannedresponses",
          type: TYPE.SINGLE,
        },
        manageChecklistLibrary: {
          key: "manageChecklistLibrary",
          name: "manageChecklistLibrary",
          label: "Manage checklist library",
          rule: "controlcenter:configuration.library",
          type: TYPE.SINGLE,
        },
        manageAutomationRules: {
          key: "manageAutomationRules",
          name: "manageAutomationRules",
          label: "Manage automation rules",
          rule: "controlcenter:configuration.automationrules",
          type: TYPE.SINGLE,
        },
        manageQARules: {
          key: "manageQARules",
          name: "manageQARules",
          label: "Manage QA rules",
          rule: "controlcenter:configuration.qarules",
          type: TYPE.SINGLE,
        },
      },
    },

    customerConfiguration: {
      key: "customer_Configuration_collection",
      label: "Customer configuration",
      type: TYPE.COLLECTION,
      blockedResource: [RESOURCE_TYPES.ADMIN, RESOURCE_TYPES.RESOURCE],
      contents: {
        customerConfiguration: {
          key: "customerConfiguration",
          name: "customerConfiguration",
          label: "Configurations",
          rule: "controlcenter::customerconf.customerconfiguration",
          type: TYPE.SINGLE,
        },
        addSLA: {
          key: "addSLA",
          name: "addSLA",
          label: "Add SLA",
          rule: "controlcenter::customerconf.addsla",
          type: TYPE.SINGLE,
        },
        manageSLA: {
          key: "manageSLA",
          name: "manageSLA",
          label: "Manage SLA",
          rule: "controlcenter::customerconf.managesla",
          type: TYPE.SINGLE,
        },
        manageWidgetsCustomerConf: {
          key: "manageWidgetsCustomerConf",
          name: "manageWidgetsCustomerConf",
          label: "Manage widgets",
          rule: "controlcenter::customerconf.managewidgets",
          type: TYPE.SINGLE,
        },
      },
    },

    generalSettings: {
      key: "general_Settings_collection",
      label: "General settings",
      type: TYPE.COLLECTION,
      blockedResource: [RESOURCE_TYPES.ADMIN, RESOURCE_TYPES.RESOURCE],
      contents: {
        generalSettingsCustomerConf: {
          key: "generalSettingsCustomerConf",
          name: "generalSettingsCustomerConf",
          label: "Update status",
          rule: "controlcenter::customerconf.generalsettings",
          type: TYPE.SINGLE,
        },
        addStatusMessage: {
          key: "addStatusMessage",
          name: "addStatusMessage",
          label: "Add status message",
          rule: "controlcenter::customerconf.addstatusmessage",
          type: TYPE.SINGLE,
        },
        updateProfileSettings: {
          key: "updateProfileSettings",
          name: "updateProfileSettings",
          label: "Update profile settings",
          rule: "controlcenter::customerconf.updateprofilesettings",
          type: TYPE.SINGLE,
        },
        updateSecuritySettingsCustomerConf: {
          key: "updateSecuritySettingsCustomerConf",
          name: "updateSecuritySettingsCustomerConf",
          label: "Update security settings",
          rule: "controlcenter::customerconf.updatesecuritysettings",
          type: TYPE.SINGLE,
        },
        updateProfessionalBadge: {
          key: "updateProfessionalBadge",
          name: "updateProfessionalBadge",
          label: "Update professional badge",
          rule: "controlcenter::customerconf.updateprofessionalbadge",
          type: TYPE.SINGLE,
        },
        updateDelegation: {
          key: "updateDelegation",
          name: "updateDelegation",
          label: "Update delegation",
          rule: "controlcenter::customerconf.updatedelegation",
          type: TYPE.SINGLE,
        },
      },
    },
  },
];

export const ColorArray = [
  "#7967D5",
  "#907BFF",
  "#A595FD",
  "#BAC1FF",
  "#C9CEFB",
  "#D8DCFF",
  "#C4F0EA",
  "#CAFFF8",
  "#9DF4E9",
  "#A6E5F7",
  "#7BD8F2",
  "#55C2E0",
  "#1CA8CF",
  "#1DBAE5",
  "#168AA9",
  "#306F93",
  "#2B6180",
  "#25536D",
  "#053D5C",
];

export const pinnedChatColors = [
  {
    primary: "#907BFF",
    tint: "#E9D8FB",
  },
  {
    primary: "#5563F5",
    tint: "#E7E9FE",
  },
  {
    primary: "#19B1F7",
    tint: "#BEEBFC",
  },
  {
    primary: "#00722A",
    tint: "#E7F7E9",
  },
  {
    primary: "#E3B309",
    tint: "#FFF4CB",
  },
  {
    primary: "#F27818",
    tint: "#FFEBDD",
  },
  {
    primary: "#EF4C54",
    tint: "#FFEEED",
  },
];

export const AllPermissions: Record<string, string> = {
  "sd::homescreen.all.rw": "02a66d3d-e72a-4aac-a3d1-ad355d494fd1",
  "sd::homescreen.self.rw": "ae2225e0-d14a-4aac-954e-5caed2428369",
  "sd::ticket.all.rw": "e74cd0c0-38e9-47da-a116-f972bed32345",
  "sd::ticket.assigned.rw": "e116e541-7a02-4022-af7f-c24e67d8f0d3",
  "sd::recurring_ticket.rw": "d4a7b2c1-8e3f-4d6a-9b5c-2f1e0a3d4c5b",
  "sd::project.all.rw": "298e8f77-f47b-457f-9492-85a110d734db",
  "sd::project.assigned.rw": "3967af3a-494a-47e9-974b-7cc1e2b72db0",
  "sd::task.all.rw": "06579dce-1f3e-46b2-b8b2-7f56c4a17847",
  "sd::task.assigned.rw": "26e74a74-245f-43e9-bcab-77b379328c99",
  "sd::announcement.all.rw": "ab9a6bbc-e0ec-45c4-a918-9aa6ca758ad0",
  "sd::announcement.self.rw": "b72c98a5-6b0c-4457-946f-a7130b6ad5c8",
  "sd::qa.all.rw": "b981c4c1-9528-466c-963e-911762f2675d",
  "sd::qa.self.rw": "276b9bfe-6be4-4c81-9e18-3c0f2d1ded29",
  "sd::timesheet.all.rw": "6f2b9ce9-e340-4f66-a410-e73bb42af259",
  "sd::timesheet.self.rw": "b66c8361-cfd8-45dc-bc40-b702b7c00bb7",
  // AAC-560 — keys + mapping_ids confirmed with backend (Uma, 18 Sep 2026): the
  // dispatch portal is filed under the `cc::` namespace there, even though the
  // portal is a Service Desk screen. See PERMISSIONS.SD below for why the
  // frontend constant still lives in the SD group.
  "cc::dispatch_portal.r": "9b7edd1b-d178-4603-a91a-73465afa589e",
  "cc::dispatch_portal.rw": "268e7325-ac1e-4cda-a4d6-a8fbd61756c3",
  "cc::company_profile.rw": "906d3723-c6b4-4f35-bdc0-88db5e4ddb30",
  "cc::company_profile.r": "76c1a611-3d9f-453d-b2d3-fdf7369fa932",
  "cc::resource.r": "51059ed0-29ac-4b64-a637-e65fb288f625",
  "cc::resource.rw": "70839c11-e6c0-4c28-98fa-4e96d3740a37",
  "cc::resource.role.r": "66fe3e02-4e61-4a1c-aa4c-64fbb38d14ab",
  "cc::resource.role.rw": "e47c75ae-7eca-44c3-8ba3-e8d4d18380c7",
  "cc::location.r": "befeb775-f82f-4525-83ef-84db83e84b16",
  "cc::location.rw": "6b41b847-50e1-42aa-bb45-7c52c2eeb2ef",
  "cc::subscription.r": "090b514c-8b57-4c0c-b21c-a553b4fe591e",
  "cc::subscription.rw": "d0a9559a-2081-4f36-88e0-7e5448897772",
  "cc::security.r": "3e184f70-8753-4f23-99c8-0a9d28b94d64",
  "cc::security.rw": "949d3e1f-d191-42cd-8a51-ade3f3769ac4",
  "cc::notification.r": "c93a2101-e3ac-4495-9e3a-cde787584809",
  "cc::notification.rw": "2f5dcd1b-cbcf-4cff-a737-bee6c215cc4c",
  "cc::channel.r": "e20ce010-f76d-410b-8af8-30121628fe00",
  "cc::channel.rw": "ecee2ee1-a960-4d45-9246-1d3d4482cd6c",
  "cc::sla.r": "972fde7d-afed-4328-82bb-74aeed805ac3",
  "cc::sla.rw": "5dbe330d-ad06-4348-acd7-db145cf15df5",
  "cc::board.r": "64335101-516d-4576-abda-0b981aabeacb",
  "cc::board.rw": "5fa73752-c734-4486-90a8-43e37ac88205",
  "cc::workflow.r": "aec59c4c-aa71-4327-94da-ea2ab474a642",
  "cc::workflow.rw": "814615d3-f0ed-4499-9873-1b09f8421573",
  "cc::custom_field.r": "8810d70b-daa6-4e1c-9011-84d47ecf9abe",
  "cc::custom_field.rw": "6c09f7ca-bbf2-4a30-a3e7-d11da0107526",
  "cc::sd_template.r": "6b670806-9a91-45e4-85d9-59f0ad41432a",
  "cc::sd_template.rw": "0fab5e54-173b-40fc-8e31-9029f2a59747",
  "cc::checklist.r": "4d91722c-34c2-4f31-93cf-642d3a662502",
  "cc::checklist.rw": "1b083e65-49a3-4135-8546-2ae0addf8e41",
  "cc::tag.r": "25f122e6-739a-4fe7-8e2b-23102f16ed03",
  "cc::tag.rw": "faed8aa7-a823-464d-b96f-165eddeafeae",
  "cc::canned_note.r": "7ed3cc37-82bd-4934-bc37-f5eeeea633d6",
  "cc::canned_note.rw": "2115c687-7406-4fbb-8b77-2d3a6fd25d79",
  "cc::qa.r": "bf8bd054-6e9b-40f3-bb04-952334a3408a",
  "cc::qa.rw": "21cefe76-78ec-4f27-b5df-f36477959f16",
  "cc::timesheet.r": "448bd0e3-441c-4e76-80cc-6a65f27aeaa3",
  "cc::timesheet.rw": "b96f6386-7d18-479e-99be-60c6ce640bfd",
  "cc::archived.r": "94be5281-01f7-4a67-8bbb-d8f5010c9095",
  "cc::archived.rw": "b27a19b2-dbc3-4400-9ccd-72187ef43d79",
  "cc::tax.r": "ecd1c563-084f-4660-9eaa-3e176732b568",
  "cc::tax.rw": "7c612526-609a-47da-9b77-87860a1b838f",
  "cc::billing_template.r": "5faedbd7-acef-4810-a5ae-ff5284db4ddd",
  "cc::billing_template.rw": "0dd1dab2-a10e-4461-9e0d-8cf8949f5b5e",
  "cc::product.r": "f2df023e-9ba3-497a-a19f-d3f9093b3c31",
  "cc::product.rw": "841fe7fb-95a9-4bc7-b3ce-ea165787b358",
  "cc::expense.r": "2bd0eb2d-6156-4a16-8e14-8a68d16e0cbd",
  "cc::expense.rw": "2869a316-8fdd-4974-8937-50e026c75c96",
  "cc::billing_setting.r": "05be3355-dc9d-411c-8ec6-ed84fe817b0f",
  "cc::billing_setting.rw": "44b0a3a5-054d-4191-bbd7-21d9c2c05d45",
  "cc::integration.r": "3e56142d-ea9e-4d28-8c92-7f16a128f906",
  "cc::integration.rw": "3c5ff434-e7c1-4ded-8ef3-faf2102ae6ec",
  "cc::integration.ninja.rw": "82e37d1f-516a-4af2-9022-d20a23dbee90",
  "cc::integration.ncentral.rw": "150524ad-37dd-4f19-b5e5-0c27775c45be",
  "cc::integration.qb.rw": "455aff37-b269-491a-b42a-664bf4f336be",
  "cc::api_management.r": "505c65f9-b94f-4d47-9983-ba2d26d3ea28",
  "cc::api_management.rw": "bf2d6abf-b706-470b-b994-fd5b399d35c8",
  "cc::channel_teams.r": "f46ddf0c-4016-420b-a172-f2f9a8260993",
  "cc::channel_teams.rw": "5dd6eb90-9401-4597-916e-d526407080f0",
  "cc::channel_desktop.r": "e4d6860c-26e1-404a-8cb5-91d37e535b65",
  "cc::channel_desktop.rw": "eddacd82-bb49-4d51-b211-444ecd4291c4",
  "cc::channel_mobile.r": "317e5f89-4418-4f59-8a5a-016b4f4aa24e",
  "cc::channel_mobile.rw": "088e0616-b496-4a27-8faf-02b70eb762bc",
  "cc::channel_email.r": "5d8b2cf2-ad2b-4311-b903-fd8172944eaf",
  "cc::channel_email.rw": "f8dc44e9-c6ff-41da-82c3-ae61300bd5d7",
  "cc::signature.r": "1572acf9-d632-4d3c-90af-5ab6651c0baa",
  "cc::signature.rw": "08f6247c-f11a-4438-a1be-53b1337b3218",
  "cc::email_template.r": "bac10f1d-91c9-4190-b9a2-03f3bc886a3d",
  "cc::email_template.rw": "86902f95-b480-45e1-ab1b-52c5d6941cab",
  "cc::branding.r": "52debf24-a129-4ecb-b71d-4e9758972a21",
  "cc::branding.rw": "94988d04-0666-4bd1-8b08-0eeef38e850a",
  "cc::helena.r": "a3a5389f-e6ee-42a5-82b0-0ea8851370b9",
  "cc::helena.rw": "16efc1f0-91b8-46ac-82eb-d1c5864ee54c",

  "billing::invoice.rw": "198adcef-6053-48e4-bcff-882282a63c93",
  "billing::invoice.r": "ff745a8f-fe4d-443c-bca1-85fd9375f89b",
  "billing::contract.rw": "041c226c-15ad-4594-93a7-9642ee6db441",
  "billing::contract.r": "aac159c1-3403-4bb5-a328-9fdc07093779",
  "billing::ready_to_bill.rw": "41eb02f4-b99c-4fe1-b28f-6acd37366b52",
  "billing::ready_to_bill.r": "f84c01dd-7515-4850-a854-c09398405dd8",
  "billing::recurring_invoice.rw": "cb394858-3c63-4573-8439-b02ee140927e",
  "billing::recurring_invoice.r": "b08ada35-d7cd-434a-8da3-612feb6c661f",
  "report::report.rw": "266f2082-dbce-43d6-8eea-09f51c5fbf55",
  "report::report.r": "dd045def-5fc4-4329-9a6a-b88d18f9174c",
  "customer::all.rw": "487ceb7f-708f-4139-a186-231fa72ef0c0",
  "customer::custom.rw": "4ec991f3-15e9-4abb-98e8-6cde7478f336",
  "kb::kb.rw": "f8d2116b-4038-41e3-8e99-2e2344c52917",
  "kb::kb.r": "08b20449-03b3-440a-9210-14f54ea1ea2b",
};

export const PERMISSIONS = {
  //
  SD: {
    SD_HOMESCREEN_ALL_RW: "sd::homescreen.all.rw",
    SD_HOMESCREEN_SELF_RW: "sd::homescreen.self.rw",
    SD_TICKET_ALL_RW: "sd::ticket.all.rw",
    SD_TICKET_ASSIGNED_RW: "sd::ticket.assigned.rw",
    SD_PROJECT_ALL_RW: "sd::project.all.rw",
    SD_PROJECT_ASSIGNED_RW: "sd::project.assigned.rw",

    SD_TASK_ALL_RW: "sd::task.all.rw",
    SD_TASK_ASSIGNED_RW: "sd::task.assigned.rw",
    SD_ANNOUNCEMENT_ALL_RW: "sd::announcement.all.rw",
    SD_ANNOUNCEMENT_SELF_RW: "sd::announcement.self.rw",
    SD_QA_ALL_RW: "sd::qa.all.rw",
    SD_QA_SELF_RW: "sd::qa.self.rw",
    SD_TIMESHEET_ALL_RW: "sd::timesheet.all.rw",
    SD_TIMESHEET_SELF_RW: "sd::timesheet.self.rw",
    SD_RECURRING_TICKET_RW: "sd::recurring_ticket.rw",

    // AAC-560 — dispatch portal. RW = full portal (queue, drag-drop, create).
    // R  = own calendar only: My-calendar day/week, no queue, no writes.
    //
    // NAMESPACE MISMATCH, deliberate: backend files these under `cc::`, but the
    // constant lives in the SD group because BOTH nav gates match on the whole
    // group — `Object.values(PERMISSIONS.SD)` opens the Service Desk parent the
    // portal sits under, and `Object.values(PERMISSIONS.CC)` (MainLayout) plus
    // `isModulePermitted("CC")` would otherwise hand a dispatch-only technician
    // the entire Control Center. Unprefixed names so the symbol doesn't assert a
    // namespace it doesn't have; the string is the only thing the API sees.
    DISPATCH_PORTAL_RW: "cc::dispatch_portal.rw",
    DISPATCH_PORTAL_R: "cc::dispatch_portal.r",
  },
  CUSTOMER: {
    CUSTOMER_ALL_RW: "customer::all.rw",
    CUSTOMER_CUSTOM_RW: "customer::custom.rw",
  },
  //

  CC: {
    // COMPANY_PROFILE_R: "cc::company_profile.r",
    CC_COMPANY_PROFILE_RW: "cc::company_profile.rw",
    // RESOURCE_R: "cc::resource.r",
    CC_RESOURCE_RW: "cc::resource.rw",
    // RESOURCE_ROLE_R: "cc::resource.role.r",
    CC_RESOURCE_ROLE_RW: "cc::resource.role.rw",
    // LOCATION_R: "cc::location.r",
    CC_LOCATION_RW: "cc::location.rw",
    // SUBSCRIPTION_R: "cc::subscription.r",
    CC_SUBSCRIPTION_RW: "cc::subscription.rw",
    // SECURITY_R: "cc::security.r",
    CC_SECURITY_RW: "cc::security.rw",
    // NOTIFICATION_R: "cc::notification.r",
    CC_NOTIFICATION_RW: "cc::notification.rw",
    // CHANNEL_R: "cc::channel.r",         SEPERATED TO EACH CHANNELS
    // CC_CHANNEL_RW: "cc::channel.rw",
    // CC_CHANNEL_TEAMS_R: "cc::channel_teams.r",
    CC_CHANNEL_TEAMS_RW: "cc::channel_teams.rw",
    // CC_CHANNEL_DESKTOP_R: "cc::channel_desktop.r",
    CC_CHANNEL_DESKTOP_RW: "cc::channel_desktop.rw",
    // CC_CHANNEL_MOBILE_R: "cc::channel_mobile.r",
    CC_CHANNEL_MOBILE_RW: "cc::channel_mobile.rw",
    // CC_CHANNEL_EMAIL_R: "cc::channel_email.r",
    CC_CHANNEL_EMAIL_RW: "cc::channel_email.rw",
    // SLA_R: "cc::sla.r",
    CC_SLA_RW: "cc::sla.rw",
    // BOARD_R: "cc::board.r",
    CC_BOARD_RW: "cc::board.rw",
    // WORKFLOW_R: "cc::workflow.r",
    CC_WORKFLOW_RW: "cc::workflow.rw",
    // CUSTOM_FIELD_R: "cc::custom_field.r",
    CC_CUSTOM_FIELD_RW: "cc::custom_field.rw",
    // SD_TEMPLATE_R: "cc::sd_template.r",
    CC_SD_TEMPLATE_RW: "cc::sd_template.rw",
    // CHECKLIST_R: "cc::checklist.r",
    CC_CHECKLIST_RW: "cc::checklist.rw",
    // TAG_R: "cc::tag.r",
    CC_TAG_RW: "cc::tag.rw",
    CC_SKILLS_RW: "cc::skills.rw",
    // CANNED_NOTE_R: "cc::canned_note.r",
    CC_CANNED_NOTE_RW: "cc::canned_note.rw",
    // QA_R: "cc::qa.r",
    CC_QA_RW: "cc::qa.rw",
    // TIMESHEET_R: "cc::timesheet.r",
    CC_TIMESHEET_RW: "cc::timesheet.rw",
    // ARCHIVED_R: "cc::archived.r",
    CC_ARCHIVED_RW: "cc::archived.rw",
    // TAX_R: "cc::tax.r",
    CC_TAX_RW: "cc::tax.rw",
    // BILLING_TEMPLATE_R: "cc::billing_template.r",
    CC_BILLING_TEMPLATE_RW: "cc::billing_template.rw",
    // PRODUCT_R: "cc::product.r",
    CC_PRODUCT_RW: "cc::product.rw",
    // EXPENSE_R: "cc::expense.r",
    CC_EXPENSE_RW: "cc::expense.rw",
    // BILLING_SETTING_R: "cc::billing_setting.r",
    CC_BILLING_SETTING_RW: "cc::billing_setting.rw",
    // INTEGRATION_R: "cc::integration.r",
    CC_INTEGRATION_RW: "cc::integration.rw",
    CC_INTEGRATION_NINJA_RW: "cc::integration.ninja.rw",
    CC_INTEGRATION_NCENTRAL_RW: "cc::integration.ncentral.rw",
    CC_INTEGRATION_QB_RW: "cc::integration.qb.rw",
    // CC_API_MANAGEMENT_R: "cc::api_management.r",
    CC_API_MANAGEMENT_RW: "cc::api_management.rw",
    CC_SIGNATURE_RW: "cc::signature.rw",
    // CC_SIGNATURE_R: "cc::signature.r",
    CC_EMAIL_TEMPLATE_RW: "cc::email_template.rw",
    // CC_EMAIL_TEMPLATE_R: "cc::email_template.r",
    CC_BRANDING_RW: "cc::branding.rw",
    // CC_BRANDING_R: "cc::branding.r",

    CC_HELENA_RW: "cc::helena.rw",
    // CC_HELENA_R: "cc::helena.r",
  },
  //
  BL: {
    BL_INVOICE_RW: "billing::invoice.rw",
    BL_INVOICE_R: "billing::invoice.r",
    BL_CONTRACT_RW: "billing::contract.rw",
    BL_CONTRACT_R: "billing::contract.r",
    BL_READY_TO_BILL_RW: "billing::ready_to_bill.rw",
    BL_READY_TO_BILL_R: "billing::ready_to_bill.r",
    BL_RECURRING_INVOICE_RW: "billing::recurring_invoice.rw",
    BL_RECURRING_INVOICE_R: "billing::recurring_invoice.r",
  },
  //
  RPT: { RPT_REPORT_RW: "report::report.rw", RPT_REPORT_R: "report::report.r" },
  //
  KB: { KB_KB_RW: "kb::kb.rw", KB_KB_R: "kb::kb.r" },
};
